/* eslint import/prefer-default-export: 0, react/no-unescaped-entities: 0 */
import {
  EN, RU, IT, ES, PL, AE, PT, DE, FR,
} from './consts';

export const langPack = {
  [EN]: {
    DOWNLOAD_APP_BTN: 'Download app',
    HOMEPAGE_FAQ_TITLE: 'Most popular questions',
    GENERAL_QUESTIONS: 'General Questions',
    CUSTOMERS_QUESTIONS: 'Customers',
    EXPERTS_QUESTIONS: 'Experts',
    PAYMENTS_QUESTIONS: 'Payments',
    BLOG_TITLE: 'Blog',
    FULL_STORY_BTN: 'Full story',
    OTHER_POSTS: 'Other posts',
    MISC: {
      DELETE: 'Delete',
      UPDATE_NOW: 'Update now',
      CONNECTING: 'Connecting',
      CONNECTING_TO_SERVER: 'Connecting to server',
      CALLING_PRO: 'Calling Pro',
      CREDIT_CARD: 'Credit card',
      ADD_A_CARD: 'Add a card',
      SUBMIT: 'Submit',
      EMAIL: 'Email',
      SAVE: 'Save',
      OK: 'OK',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
      PLEASE_ENTER_LAST_NAME: 'Please enter last name',
      YOU_WILL_PAY: 'You will pay',
      PER_MINUTE_FOR_CALL: 'per minute for this call',
      MINUTES_SHORT: 'min',
      BECOME_PRO: 'Become a Pro',
      BLOG: 'Blog',
      FIND_A_PRO: 'Find a Pro',
      MY_CLIENTS: 'My Clients',
      MY_PROS: 'My Pros',
      MY_APPOINTMENTS: 'My Appointments',
      SIGN_UP: 'Sign Up',
      LOG_OUT: 'Log out',
      REGISTER_AS_PRO: 'Register as Pro',
      REGISTER: 'Register',
      LOG_IN: 'Log in',
      FORGOT_PASSWORD: 'Forgot password',
      PASSWORD: 'Password',
      DATE: 'Date',
      DATE_AND_TIME: 'Date and time',
      DURATION: 'Duration',
      TYPE: 'Type',
      EDIT: 'Edit',
      NAME: 'Name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      MOBILE: 'Mobile',
      CITY: 'City',
      BUSINESS_NAME: 'Business name',
      COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
      COUNTRY: 'Country',
      RATE: 'Rate',
      YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
      CODE_VERIFIED: 'Code verified',
      IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
      CODE_EXPIRES_IN: 'Code expires in',
      CODE: 'Code',
      VERIFY_CODE: 'Verify code',
      PLEASE_ENTER_EMAIL: 'Please enter email',
      RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
      SEND_VERIFICATION_CODE: 'Send verification code',
      LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully',
    },
    BLOG: {
      COMMENTS: 'Comments',
      REPLY: 'Reply',
      ADD_COMMENT: 'Add Comment',
      POST_COMMENT: 'Post comment',
    },
    BOOKING: {
      CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
      CANCELLATION_POLICY: 'Cancellation Policy',
      CANCEL_APPOINTMENT: 'Cancel Appointment',
      PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
      YES_CANCEL: 'Yes, cancel',
      NO_KEEP: 'No, keep it',
    },
    COMMUNICATION: {
      ON_CALL_WITH: 'On call with',
      CONNECTING_WITH: 'Connecting with',
      INCOMING_CALL: 'Incoming Call',
      YOUR_CLIENT: 'Your client',
      TYPE_YOUR_MESSAGE: 'Type your message',
      MIN: 'min',
      CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.',
    },
    CREDIT_CARD: {
      CARD_NUMBER: 'Card number',
      CARD_HOLDER: 'Card holder',
      EXPIRY_DATE: 'Expiry date',
      CVV: 'CVV',
      CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
      SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
      SAVE_PAYMENT_METHOD: 'Save payment method',
      X2_BONUS: 'x2 BONUS',
      YOU_WILL_GET: 'You will get',
      TELMIE_CREDIT: 'Telmie credit',
      IN_TOTAL: 'in total',
      CONFIRM_AND_PAY: 'Confirm & Pay',
      CANNOT_WITHDRAW: 'Cannot withdraw',
      FEE: 'fee',
      FREE: 'Free',
      YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
      AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
      AVALIABLE: 'Available',
      AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
      WITHDRAW: 'Withdraw',
      FREE_APPLIES: 'Fee applies: ',
      YOU_RECEIVE: 'You receive: ',
      WITHDRAWAL_RULES: 'Withdrawal rules',
      WITHDRAWAL_AMOUNT: 'Withdrawal amount',
      HIDE: 'Hide',
      SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules',
    },
    EDIT_PROFILE: {
      SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
      CANT_BE_CHANGED: 'Can\'t be changed',
      UPLOAD_PICTURE: 'Upload picture',
      NAME_ISNT_VALID: 'The name isn\'t valid.',
    },
    FEATURED_SERVICE: {
      CALL_NOW: 'Call now',
      CANCEL_CALL: 'Cancel call',
      NEXT_PRO: 'Next pro',
      NEXT_PRO_CAPS: 'NEXT PRO',
      THEN_CAPS: 'THEN',
    },
    HEADER: {
      HOW_IT_WORKS: 'How it works',
      FAQ: 'FAQ',
      CONTACT: 'Contact us',
      MONEY: 'Money',
      SETTINGS: 'Settings',
      LOGIN: 'Log in',
      EDIT_PROFILE: 'Edit Profile',
      NEW_CHATS: 'New Chats',
      WELL_DONE: 'Well done',
      SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
      EDIT_PRO_DETAILS: 'Edit Pro details',
    },
    HOMEPAGE: {
      FEATURED_PROS: 'Featured Pros',
      FEATURED_SERVICES: 'Featured services',
      DOWNLOAD_TELMIE_APP: 'Download Telmie app',
    },
    LANGUAGE_PRACTICE: {
      HAPPY_PROS: 'Happy Pros',
      HAPPY_USERS: 'Happy Users',
    },
    LOG_IN: {
      LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
      NEW_TO_TELMIE: 'New to Telmie',
      DOWNLOAD_THE_APP: 'Download the app',
    },
    NEW_LANDING: {
      MINUTES: 'minutes',
      COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
      BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
      PLEASE_ENTER_SUBJECT: 'Please enter subject',
      PLEASE_ENTER_MESSAGE: 'Please enter message',
    },
    PRO: {
      PRO: 'Pro',
      AMOUNT: 'Amount',
      NO_RECENT_CALLS: 'No recent calls',
      MESSAGES: 'Messages',
      START_CALL: 'Start Call',
      SHORTLISTED: 'Shortlisted',
      REMOVE: 'Remove',
      SHORTLIST: 'Shortlist',
      LOADING: 'Loading',
      TELMIE_CLIENT: 'Telmie Client',
      ON_CALL: 'On call',
      RECONNECTING: 'Reconnecting...',
      TELMIE_USER_IS_CALLING: 'Telmie user is calling',
      SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
      HOURS_FIRST_LETTER: 'h',
      MINUTES_FIRST_LETTER: 'm',
      CALENDAR_TITLE: 'My availability',
      CALENDAR_SUB_TITLE: 'I am not available right now',
      CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
      AVAILABLE_NOW: 'Available now',
      AVAILABLE_LATTER: 'Available later',
      WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
      PRO_IS_BUSY: 'Pro is busy',
    },
    PROFILE: {
      VIEW_ALL: 'View all',
      CONTACT: 'Contact',
      COUNT: 'Count',
      NO_RECENT_ACTIVITY: 'No recent activity',
      YOUR_DETAILS: 'Your details',
      LOCATION: 'Location',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      NO_RECENT_PROS: 'No recent PROS',
      WITHDRAW_EARNINGS: 'Withdraw earnings',
      TOP_UP: 'Top Up',
      ATTACH_CARD: 'Attach card',
      SERVICE: 'Service',
      APPOINTMENT_WITH: 'Appointment with',
      COST: 'Cost',
      BALANCE: 'Balance',
      NO_RECENT_TRANSACTIONS: 'No recent transactions',
      NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
      CLIENT: 'Client',
    },
    RADIO_BUTTONS: {
      APPROVED: 'Approved',
      SECTORS: 'SECTORS',
    },
    SEARCH: {
      FILTERS: 'Filters',
      SESSIONS: 'sessions',
      ARRANGE_BY: 'Arrange by',
      ENTER_KEYWORDS: 'Enter keywords',
      RESET_FILTERS: 'Clear all',
    },
    SELECT: {
      EVERY: 'Every',
    },
    SETTINGS: {
      IMPORTANT_VIA_EMAIL: 'Important via email',
      WORKING_AS_PRO: 'Working as Pro',
      PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
      ADD_NEW_PERIOD: 'Add new period',
      CHANGE_BANK_ACCOUNT: 'Change bank account',
      ADD_BANK_ACCOUNT: 'Add bank account',
      ENTITY: 'Entity',
      ADDRESS: 'Address',
      YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
      WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
      SORT_CODE: 'Sort code',
      DIGITS_VALUE: 'digits value',
      ACCOUNT_NUMBER: 'Account number',
      BAD_REQUEST_DATA: 'Bad Request data',
      PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
      CONFIRM: 'Confirm',
      UPLOAD_ANOTHER_IMAGE: 'Upload another image',
      UPLOAD: 'Upload',
      YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
      YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
      PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
      POST_CODE: 'Post Code',
      LOADING_CARDS: 'Loading cards',
      NO_CARDS: 'No cards.',
      COMPANY_ADDRESS: 'Company address',
      PERSONAL_ADDRESS: 'Personal address',
      SERVICE_NAME: 'Service name',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_SUB_CATEGORY: 'Service sub-category',
      SERVICE_DESCRIPTION: 'Service description',
      PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
      LOADING_ACCOUNTS: 'Loading accounts',
      ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
      PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
      THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
      DAYS_REQUIRED: 'Please select days',
      FROM: 'From',
      TO: 'To',
      COMPANY: 'Company',
      INDIVIDUAL: 'Individual',
      PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
      PROFILE_DETAILS: 'Profile details',
      PRO_SETTINGS: 'PRO SETTINGS',
      WORK_AS_PRO: 'Work as Pro',
      PRO_DETAILS: 'Pro details',
      PAYOUT_BANK_DETAILS: 'Payout bank details',
      PREVIEW_MY_PROFILE: 'Preview my profile',
      MY_AVAILABILITY: 'My availability',
      HIDE_PROFILE: 'Hide profile',
      GENERAL_SETTINGS: 'GENERAL SETTINGS',
      PAYMENT_SETTINGS: 'Payment settings',
      EMAIL_NOTIFICATION: 'Email notification',
      BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
      BANK_ACCOUNT: 'Bank account',
      ID_VERIFICATION: 'ID Verification',
      I_WANT_TO_TAKE_PART: 'I want to take part',
    },
    SIGN_UP: {
      CONFIRM_EMAIL: 'Now confirm your email address',
      RESEND: 'Resend',
      CONFIRM_EMAIL_MESSAGE: (email) => <span>We've sent an email to {email}, please check your inbox and click the link "Activate" to confirm and earn!</span>,
      USE_ANOTHER_EMAIL: 'Use another email',
      SECTOR: 'Sector',
      CATEGORY: 'Category',
      PLEASE_SELECT_CATEGORY: 'Please select category',
      PROFESSION: 'Profession',
      DESCRIPTION: 'Description',
      FREE: 'Free',
      PER_MINUTE: 'per minute',
      BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
      TERMS_OF_USE: 'Terms of use',
      AND_THE: 'and the',
      PRIVACY_POLICY: 'Privacy Policy',
      THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
      CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
      ACCOUNT_TYPE: 'Account type',
      APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
      CANCEL_CHANGES: 'Cancel changes',
      PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
      ERROR: 'Error',
      PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
      UNITED_KINGDOM: 'United Kingdom',
      ONLY_UK_NOW: 'Only UK for now',
      I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
      ALREADY_HAVE_ACCOUNT: 'Already have an account',
      CODE_HAVE_BEEN_SENT: 'Code has been sent to',
      EDUCATION: {
        EDUCATION: 'Education',
        LANGUAGE_TUTOR: 'Language tutor',
        LANGUAGE_PRACTICE: 'Language practice',
        EXAMS_PREPARATION: 'Exams preparation',
        SCIENCE: 'Science',
        BUSINESS_STUDIES: 'Business studies',
        SOCIAL_SCIENCE: 'Social science',
        DRAWING: 'Drawing',
        MUSIC: 'Music',
        DANCE: 'Dance',
      },
      SERVICES: {
        SERVICES: 'Services',
        INTERPRETER: 'Interpreter',
        NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
        THERAPIST: 'Therapist',
        LISTENER: 'Listener',
        SPEECH_THERAPIST: 'Speech therapist',
        FORTUN_TELLER: 'Fortun teller',
        ASTROLOGIST: 'Astrologist',
        PERSONAL_ASSISTANT: 'Personal assistant',
        CAREER_COACH: 'Career coach',
      },
      CONSULTANCY: {
        CONSULTANCY: 'Consultancy',
        LEGAL: 'Legal',
        MEDICAL: 'Medical',
        BUSINESS: 'Business',
        FAMILY: 'Family',
        INVESTMENT: 'Investment',
        TECH_SUPPORT: 'Tech support',
        BEAUTICIAN: 'Beautician',
      },
      HEALTH_LIFESTYLE: {
        HEALTH_LIFESTYLE: 'Health&Lifestyle',
        PERSONAL_TRAINER: 'Personal trainer',
        YOGA_INSTRUCTOR: 'Yuga instructor',
        MEDITATION_INSTRUCTOR: 'Meditation instructor',
        DIETOLOGIST: 'Dietologist',
        SPORT_COACH: 'Sport coach',
        FITNESS_PROFESSIONAL: 'Fitness professional',
        SPIRITUAL_COACH: 'Spiritual coach',
      },
      PLEASE_SELECT_SECTOR: 'Please select sector',
      PLEASE_ENTER_PROFESSION: 'Please enter profession',
      PLEASE_ENTER_DESCRIPTION: 'Please enter description',
      PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
      PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
      YOU_ARE_UNDER_18: 'You are under 18',
      DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
      YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
      PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
      CITY_IN_THE_UK: 'City in the UK',
      CITY_INCORRECT: 'City incorrect',
      POSTCODE: 'Postcode',
      PLEASE_ENTER_POSTCODE: 'Please enter postcode',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      ONLY_UK_ADDRESS: 'Only UK address',
      ADDRESS_INCORRECT: 'Address incorrect',
      ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
      BIRTHDAY_INCORRECT: 'Birthday incorrect',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      WE_WONT_SHARE_IT: 'We won\'t share it with others.',
      MOBILE_INCORRECT: 'Mobile incorrect',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      EG_IO: 'e.g. i0ONOZLgCIM',
      SERVICE_INCORRECT: 'Service incorrect',
      SERVICE_LABEL: 'Service (20 characters)',
      IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
      SERVICE_NAME_INCORRECT: 'Service name incorrect',
      SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
      SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
      SERVICE_DESCRIPTION: 'Service description (500-10000 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
      PRICE_PER_MINUTE: 'Price per minute',
      DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
      YES: 'Yes.',
      NO: 'No.',
      DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
      YES_SAVE: 'Yes, save.',
      DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
      ENTER_TAX_ID: 'Enter tax ID to check',
      CHECK: 'Check.',
      PLEASE_ENTER_PASSWORD: 'Please enter password',
      FIRST_NAME: 'First name',
    },
    SOCIAL_NETWORK: {
      CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
      CONTINUE_WITH_GOOGLE: 'Continue with Google',
    },
    ROUTES: {
      ERROR_404: 'Error 404',
      PAGE_NOT_FOUND: 'Page not found',
      THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
      GO_HOME: 'Go Home',
      FEATURED_SERVICE: 'FEATURED SERVICE',
      WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
      GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
      FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
      CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
      NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
      YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
      RESET: 'Reset',
      BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
      TELMIE_T_C: 'Telmie T&C',
      TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
      AND: 'and',
      STRIPE_T_C: 'Stripe T&C.',
      SORRY: 'Sorry',
      IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
      OR: 'or',
      IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
      BACK_TO_SETTINGS: 'Back to Settings',
      PROFILE_PREVIEW: 'Profile preview',
      PRO_DETAILS: 'Pro details',
      PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
      RESULTS_FOR: 'Results for',
      SORRY_NO_PROS: 'Sorry, no pros found for',
      SELECT_YOUR_INTEREST: 'Select your interest',
      TELMIE_MY_CLIENTS: 'Telmie | My Clients',
      FIND_YOUR_CLIENT: 'Find your Client',
      TELMIE_MY_PROS: 'Telmie | My Pros',
      FIND_YOUR_PRO: 'Find your Pro',
      PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
      TELMIE_PREVIEW: 'Telmie | Preview',
      LOWEST_RATE_FIRST: 'Lowest rate first',
      HIGHEST_RATE_FIRST: 'Highest rate first',
      EXPERIENCE: 'Experience',
      RATING: 'Rating',
      ACTIVITY: 'Activity',
      LANGUAGES: 'Languages',
      COACHING: 'Coaching',
      IMMIGRATION: 'Immigration',
      OTHER: 'Other',
      ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
      ERROR_WITH_STRIPE: 'Error with Stripe.',
      TELMIE_PRO: 'Telmie | Pro',
    },
    FOOTER: {
      HOME: 'Home',
      CONTACT: 'Contact',
      SUPPORT: 'Support',
      POLICY: 'Privacy Policy',
      CANCELLATION: 'Booking Cancellation Policy',
      TERMS: 'Terms',
      FAQ: 'FAQ',
      COPYRIGHT: 'Copyright',
      COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom',
    },
    CONTACT_US: {
      title: 'Contact us',
      subTitle: 'Any questions? Drop us a line.',
      name: 'Your name',
      email: 'Your email',
      company: 'Company',
      subject: 'Subject',
      message: 'Your message',
      success: 'Your message has been sent. Thank you!',
      submitBtn: 'Submit',
    },
    SERVICES: {
      LANGUAGE_PRACTICE: 'Language practice',
      IMMIGRATION_CONSULTANT: 'Immigration Pro',
      IMMIGRATION_ADVICE: 'Immigration advice',
      LANGUAGE_LEARNERS: 'Language learning',
    },
    FAQ: 'FAQ',
    MORE_FAQ: 'More FAQ',
    API: {
      NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content',
    },
    NOTIFICATIONS: {
      DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
      EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
      MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
      SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
      UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!',
    },
    REGISTER_PRO: {
      FIRST_NAME: 'First name',
      FIRST_NAME_ERROR: 'First name field is required',
      LAST_NAME: 'Last name',
      LAST_NAME_ERROR: 'Last name field is required',
      COUNTRY: 'Country',
      COUNTRY_PLACEHOLDER: 'Select country',
      COUNTRY_ERROR: 'Country field is required',
      CITY: 'City',
      POSTCODE: 'Postcode',
      POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
      DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
      DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      MOBILE_HINT: 'We won\'t share it with others.',
      MOBILE_ERROR: 'Must contain only numbers',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
      SERVICES: 'Services',
      SERVICES_PLACEHOLDER: 'Select service',
      SERVICES_ERROR: 'Services field is required',
      SERVICE: 'Service (20 characters)',
      SERVICE_HINT: 'i.e. English practice, Immigration advice',
      SERVICE_ERROR: 'Service name may not be greater than 20 characters',
      SECTOR: 'Sector',
      SECTOR_PLACEHOLDER: 'Select sector',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
      SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
      SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
      SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
      SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
      COST_PER_MINUTE_ERROR: 'Please enter price',
      COST_PER_MINUTE_MAX: 'Maximum allowed for this service',
    },
  },
  [RU]: {
    DOWNLOAD_APP_BTN: 'Скачать приложение',
    HOMEPAGE_FAQ_TITLE: 'Популярные вопросы',
    GENERAL_QUESTIONS: 'Общие вопросы',
    CUSTOMERS_QUESTIONS: 'Клиенты',
    EXPERTS_QUESTIONS: 'Эксперты',
    PAYMENTS_QUESTIONS: 'Оплата',
    BLOG_TITLE: 'Блог',
    FULL_STORY_BTN: 'Подробнее',
    OTHER_POSTS: 'Другие статьи',
    MISC: {
      DELETE: 'Delete',
      UPDATE_NOW: 'Update now',
      CONNECTING: 'Connecting',
      CONNECTING_TO_SERVER: 'Connecting to server',
      CALLING_PRO: 'Calling Pro',
      CREDIT_CARD: 'Credit card',
      ADD_A_CARD: 'Add a card',
      SUBMIT: 'Submit',
      EMAIL: 'Email',
      SAVE: 'Save',
      OK: 'OK',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
      PLEASE_ENTER_LAST_NAME: 'Please enter last name',
      YOU_WILL_PAY: 'You will pay',
      PER_MINUTE_FOR_CALL: 'per minute for this call',
      MINUTES_SHORT: 'min',
      BECOME_PRO: 'Become a Pro',
      BLOG: 'Блог',
      FIND_A_PRO: 'Find a Pro',
      MY_APPOINTMENTS: 'My Appointments',
      MY_CLIENTS: 'My Clients',
      MY_PROS: 'My Pros',
      SIGN_UP: 'Sign Up',
      LOG_OUT: 'Log out',
      REGISTER_AS_PRO: 'Register as Pro',
      REGISTER: 'Register',
      LOG_IN: 'Log in',
      FORGOT_PASSWORD: 'Forgot password',
      PASSWORD: 'Password',
      DATE: 'Date',
      DATE_AND_TIME: 'Date and time',
      DURATION: 'Duration',
      TYPE: 'Type',
      EDIT: 'Edit',
      NAME: 'Name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      MOBILE: 'Mobile',
      CITY: 'City',
      BUSINESS_NAME: 'Business name',
      COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
      COUNTRY: 'Country',
      RATE: 'Rate',
      YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
      CODE_VERIFIED: 'Code verified',
      IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
      CODE_EXPIRES_IN: 'Code expires in',
      CODE: 'Code',
      VERIFY_CODE: 'Verify code',
      PLEASE_ENTER_EMAIL: 'Please enter email',
      RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
      SEND_VERIFICATION_CODE: 'Send verification code',
      LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully',
    },
    BLOG: {
      COMMENTS: 'Comments',
      REPLY: 'Reply',
      ADD_COMMENT: 'Add Comment',
      POST_COMMENT: 'Post comment',
      YES_CANCEL: 'Yes, cancel',
      NO_KEEP: 'No, keep it',
    },
    BOOKING: {
      CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
      CANCELLATION_POLICY: 'Cancellation Policy',
      CANCEL_APPOINTMENT: 'Cancel Appointment',
      PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
    },
    COMMUNICATION: {
      ON_CALL_WITH: 'On call with',
      CONNECTING_WITH: 'Connecting with',
      INCOMING_CALL: 'Incoming Call',
      YOUR_CLIENT: 'Your client',
      TYPE_YOUR_MESSAGE: 'Type your message',
      MIN: 'min',
      CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.',
    },
    CREDIT_CARD: {
      CARD_NUMBER: 'Card number',
      CARD_HOLDER: 'Card holder',
      EXPIRY_DATE: 'Expiry date',
      CVV: 'CVV',
      CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
      SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
      SAVE_PAYMENT_METHOD: 'Save payment method',
      X2_BONUS: 'x2 BONUS',
      YOU_WILL_GET: 'You will get',
      TELMIE_CREDIT: 'Telmie credit',
      IN_TOTAL: 'in total',
      CONFIRM_AND_PAY: 'Confirm & Pay',
      CANNOT_WITHDRAW: 'Cannot withdraw',
      FEE: 'fee',
      FREE: 'Free',
      YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
      AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
      AVALIABLE: 'Available',
      AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
      WITHDRAW: 'Withdraw',
      FREE_APPLIES: 'Fee applies: ',
      YOU_RECEIVE: 'You receive: ',
      WITHDRAWAL_RULES: 'Withdrawal rules',
      WITHDRAWAL_AMOUNT: 'Withdrawal amount',
      HIDE: 'Hide',
      SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules',
    },
    EDIT_PROFILE: {
      SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
      CANT_BE_CHANGED: 'Can\'t be changed',
      UPLOAD_PICTURE: 'Upload picture',
      NAME_ISNT_VALID: 'The name isn\'t valid.',
    },
    FEATURED_SERVICE: {
      CALL_NOW: 'Call now',
      CANCEL_CALL: 'Cancel call',
      NEXT_PRO: 'Next pro',
      NEXT_PRO_CAPS: 'NEXT PRO',
      THEN_CAPS: 'THEN',
    },
    HEADER: {
      HOW_IT_WORKS: 'O нас',
      FAQ: 'Часто задаваемые вопросы',
      CONTACT: 'Связь с нами',
      MONEY: 'Money',
      SETTINGS: 'Settings',
      LOGIN: 'Log in',
      EDIT_PROFILE: 'Edit Profile',
      NEW_CHATS: 'New Chats',
      WELL_DONE: 'Well done',
      SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
      EDIT_PRO_DETAILS: 'Edit Pro details',
    },
    HOMEPAGE: {
      FEATURED_PROS: 'Featured Pros',
      FEATURED_SERVICES: 'Featured services',
      DOWNLOAD_TELMIE_APP: 'Download Telmie app',
    },
    LANGUAGE_PRACTICE: {
      HAPPY_PROS: 'Happy Pros',
      HAPPY_USERS: 'Happy Users',
    },
    LOG_IN: {
      LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
      NEW_TO_TELMIE: 'New to Telmie',
      DOWNLOAD_THE_APP: 'Download the app',
    },
    NEW_LANDING: {
      MINUTES: 'minutes',
      COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
      BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
      PLEASE_ENTER_SUBJECT: 'Please enter subject',
      PLEASE_ENTER_MESSAGE: 'Please enter message',
    },
    PRO: {
      PRO: 'Pro',
      AMOUNT: 'Amount',
      NO_RECENT_CALLS: 'No recent calls',
      MESSAGES: 'Messages',
      START_CALL: 'Start Call',
      SHORTLISTED: 'Shortlisted',
      REMOVE: 'Remove',
      SHORTLIST: 'Shortlist',
      LOADING: 'Loading',
      TELMIE_CLIENT: 'Telmie Client',
      ON_CALL: 'On call',
      RECONNECTING: 'Reconnecting...',
      TELMIE_USER_IS_CALLING: 'Telmie user is calling',
      SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
      HOURS_FIRST_LETTER: 'h',
      MINUTES_FIRST_LETTER: 'm',
      CALENDAR_TITLE: 'My availability',
      CALENDAR_SUB_TITLE: 'I am not available right now',
      CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
      AVAILABLE_NOW: 'Available now',
      AVAILABLE_LATTER: 'Available later',
      WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
      PRO_IS_BUSY: 'Pro is busy',
    },
    PROFILE: {
      VIEW_ALL: 'View all',
      CONTACT: 'Contact',
      COUNT: 'Count',
      NO_RECENT_ACTIVITY: 'No recent activity',
      YOUR_DETAILS: 'Your details',
      LOCATION: 'Location',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      NO_RECENT_PROS: 'No recent PROS',
      WITHDRAW_EARNINGS: 'Withdraw earnings',
      TOP_UP: 'Top Up',
      ATTACH_CARD: 'Attach card',
      SERVICE: 'Service',
      APPOINTMENT_WITH: 'Appointment with',
      COST: 'Cost',
      BALANCE: 'Balance',
      NO_RECENT_TRANSACTIONS: 'No recent transactions',
      NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
      CLIENT: 'Client',
    },
    RADIO_BUTTONS: {
      APPROVED: 'Approved',
      SECTORS: 'SECTORS',
    },
    SEARCH: {
      FILTERS: 'Фильтры',
      SESSIONS: 'sessions',
      ARRANGE_BY: 'Arrange by',
      ENTER_KEYWORDS: 'Enter keywords',
      RESET_FILTERS: 'Сбросить фильтры',
    },
    SELECT: {
      EVERY: 'Every',
    },
    SETTINGS: {
      IMPORTANT_VIA_EMAIL: 'Important via email',
      WORKING_AS_PRO: 'Working as Pro',
      PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
      ADD_NEW_PERIOD: 'Add new period',
      CHANGE_BANK_ACCOUNT: 'Change bank account',
      ADD_BANK_ACCOUNT: 'Add bank account',
      ENTITY: 'Entity',
      ADDRESS: 'Address',
      YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
      WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
      SORT_CODE: 'Sort code',
      DIGITS_VALUE: 'digits value',
      ACCOUNT_NUMBER: 'Account number',
      BAD_REQUEST_DATA: 'Bad Request data',
      PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
      CONFIRM: 'Confirm',
      UPLOAD_ANOTHER_IMAGE: 'Upload another image',
      UPLOAD: 'Upload',
      YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
      YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
      PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
      POST_CODE: 'Post Code',
      LOADING_CARDS: 'Loading cards',
      NO_CARDS: 'No cards.',
      COMPANY_ADDRESS: 'Company address',
      PERSONAL_ADDRESS: 'Personal address',
      SERVICE_NAME: 'Service name',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_SUB_CATEGORY: 'Service sub-category',
      SERVICE_DESCRIPTION: 'Service description',
      PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
      LOADING_ACCOUNTS: 'Loading accounts',
      ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
      PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
      THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
      DAYS_REQUIRED: 'Please select days',
      FROM: 'From',
      TO: 'To',
      COMPANY: 'Company',
      INDIVIDUAL: 'Individual',
      PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
      PROFILE_DETAILS: 'Profile details',
      PRO_SETTINGS: 'PRO SETTINGS',
      WORK_AS_PRO: 'Work as Pro',
      PRO_DETAILS: 'Pro details',
      PAYOUT_BANK_DETAILS: 'Payout bank details',
      PREVIEW_MY_PROFILE: 'Preview my profile',
      MY_AVAILABILITY: 'My availability',
      HIDE_PROFILE: 'Hide profile',
      GENERAL_SETTINGS: 'GENERAL SETTINGS',
      PAYMENT_SETTINGS: 'Payment settings',
      EMAIL_NOTIFICATION: 'Email notification',
      BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
      BANK_ACCOUNT: 'Bank account',
      ID_VERIFICATION: 'ID Verification',
      I_WANT_TO_TAKE_PART: 'I want to take part',
    },
    SIGN_UP: {
      CONFIRM_EMAIL: 'Now confirm your email address',
      RESEND: 'Resend',
      CONFIRM_EMAIL_MESSAGE: (email) => <span>We've sent an email to {email}, please check your inbox and click the link 'Activate' to confirm and earn!</span>,
      USE_ANOTHER_EMAIL: 'Use another email',
      SECTOR: 'Sector',
      CATEGORY: 'Category',
      PLEASE_SELECT_CATEGORY: 'Please select category',
      PROFESSION: 'Profession',
      DESCRIPTION: 'Description',
      FREE: 'Free',
      PER_MINUTE: 'per minute',
      BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
      TERMS_OF_USE: 'Terms of use',
      AND_THE: 'and the',
      PRIVACY_POLICY: 'Privacy Policy',
      THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
      CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
      ACCOUNT_TYPE: 'Account type',
      APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
      CANCEL_CHANGES: 'Cancel changes',
      PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
      ERROR: 'Error',
      PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
      UNITED_KINGDOM: 'United Kingdom',
      ONLY_UK_NOW: 'Only UK for now',
      I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
      ALREADY_HAVE_ACCOUNT: 'Already have an account',
      CODE_HAVE_BEEN_SENT: 'Code has been sent to',
      EDUCATION: {
        EDUCATION: 'Education',
        LANGUAGE_TUTOR: 'Language tutor',
        LANGUAGE_PRACTICE: 'Language practice',
        EXAMS_PREPARATION: 'Exams preparation',
        SCIENCE: 'Science',
        BUSINESS_STUDIES: 'Business studies',
        SOCIAL_SCIENCE: 'Social science',
        DRAWING: 'Drawing',
        MUSIC: 'Music',
        DANCE: 'Dance',
      },
      SERVICES: {
        SERVICES: 'Services',
        INTERPRETER: 'Interpreter',
        NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
        THERAPIST: 'Therapist',
        LISTENER: 'Listener',
        SPEECH_THERAPIST: 'Speech therapist',
        FORTUN_TELLER: 'Fortun teller',
        ASTROLOGIST: 'Astrologist',
        PERSONAL_ASSISTANT: 'Personal assistant',
        CAREER_COACH: 'Career coach',
      },
      CONSULTANCY: {
        CONSULTANCY: 'Consultancy',
        LEGAL: 'Legal',
        MEDICAL: 'Medical',
        BUSINESS: 'Business',
        FAMILY: 'Family',
        INVESTMENT: 'Investment',
        TECH_SUPPORT: 'Tech support',
        BEAUTICIAN: 'Beautician',
      },
      HEALTH_LIFESTYLE: {
        HEALTH_LIFESTYLE: 'Health&Lifestyle',
        PERSONAL_TRAINER: 'Personal trainer',
        YOGA_INSTRUCTOR: 'Yuga instructor',
        MEDITATION_INSTRUCTOR: 'Meditation instructor',
        DIETOLOGIST: 'Dietologist',
        SPORT_COACH: 'Sport coach',
        FITNESS_PROFESSIONAL: 'Fitness professional',
        SPIRITUAL_COACH: 'Spiritual coach',
      },
      PLEASE_SELECT_SECTOR: 'Please select sector',
      PLEASE_ENTER_PROFESSION: 'Please enter profession',
      PLEASE_ENTER_DESCRIPTION: 'Please enter description',
      PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
      PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
      YOU_ARE_UNDER_18: 'You are under 18',
      DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
      YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
      PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
      CITY_IN_THE_UK: 'City in the UK',
      CITY_INCORRECT: 'City incorrect',
      POSTCODE: 'Postcode',
      PLEASE_ENTER_POSTCODE: 'Please enter postcode',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      ONLY_UK_ADDRESS: 'Only UK address',
      ADDRESS_INCORRECT: 'Address incorrect',
      ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
      BIRTHDAY_INCORRECT: 'Birthday incorrect',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      WE_WONT_SHARE_IT: 'We won\'t share it with others.',
      MOBILE_INCORRECT: 'Mobile incorrect',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      EG_IO: 'e.g. i0ONOZLgCIM',
      SERVICE_INCORRECT: 'Service incorrect',
      SERVICE_LABEL: 'Service (20 characters)',
      IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
      SERVICE_NAME_INCORRECT: 'Service name incorrect',
      SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
      SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
      SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
      PRICE_PER_MINUTE: 'Price per minute',
      DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
      YES: 'Yes.',
      NO: 'No.',
      DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
      YES_SAVE: 'Yes, save.',
      DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
      ENTER_TAX_ID: 'Enter tax ID to check',
      CHECK: 'Check.',
      PLEASE_ENTER_PASSWORD: 'Please enter password',
      FIRST_NAME: 'First name',
    },
    SOCIAL_NETWORK: {
      CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
      CONTINUE_WITH_GOOGLE: 'Continue with Google',
    },
    ROUTES: {
      ERROR_404: 'Error 404',
      PAGE_NOT_FOUND: 'Page not found',
      THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
      GO_HOME: 'Go Home',
      FEATURED_SERVICE: 'FEATURED SERVICE',
      WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
      GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
      FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
      CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
      NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
      YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
      RESET: 'Reset',
      BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
      TELMIE_T_C: 'Telmie T&C',
      TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
      AND: 'and',
      STRIPE_T_C: 'Stripe T&C.',
      SORRY: 'Sorry',
      IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
      OR: 'or',
      IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
      BACK_TO_SETTINGS: 'Back to Settings',
      PROFILE_PREVIEW: 'Profile preview',
      PRO_DETAILS: 'Pro details',
      PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
      RESULTS_FOR: 'Results for',
      SORRY_NO_PROS: 'Sorry, no pros found for',
      SELECT_YOUR_INTEREST: 'Select your interest',
      TELMIE_MY_CLIENTS: 'Telmie | My Clients',
      FIND_YOUR_CLIENT: 'Find your Client',
      TELMIE_MY_PROS: 'Telmie | My Pros',
      FIND_YOUR_PRO: 'Find your Pro',
      PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
      TELMIE_PREVIEW: 'Telmie | Preview',
      LOWEST_RATE_FIRST: 'Lowest rate first',
      HIGHEST_RATE_FIRST: 'Highest rate first',
      EXPERIENCE: 'Experience',
      RATING: 'Rating',
      ACTIVITY: 'Activity',
      LANGUAGES: 'Languages',
      COACHING: 'Coaching',
      IMMIGRATION: 'Immigration',
      OTHER: 'Other',
      ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
      ERROR_WITH_STRIPE: 'Error with Stripe.',
      TELMIE_PRO: 'Telmie | Pro',
    },
    FOOTER: {
      HOME: 'Главная',
      CONTACT: 'Контакт',
      SUPPORT: 'Поддержка',
      POLICY: 'Политика приватности',
      TERMS: 'Условия',
      FAQ: 'ЧаВо',
      COPYRIGHT: 'Copyright',
      COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom',
    },
    CONTACT_US: {
      title: 'Как с нами связаться?',
      subTitle: 'Есть вопросы? Напишите нам.',
      name: 'Ваше имя',
      email: 'Ваш имейл',
      company: 'Название компании',
      subject: 'Тема',
      message: 'Ваше сообщение',
      success: 'Ваше сообщение было отправлено. Спасибо!',
      submitBtn: 'Отправить',
    },
    SERVICES: {
      LANGUAGE_PRACTICE: 'Практика английского',
      IMMIGRATION_ADVICE: 'Иммиграционные консультации',
      IMMIGRATION_CONSULTANT: 'Иммиграционная помощь',
      LANGUAGE_LEARNERS: 'Изучение языка',
    },
    FAQ: 'Часто задаваемые вопросы',
    MORE_FAQ: 'Больше вопросов',
    API: {
      NOTIFICATION_MESSAGE: 'Пожалуйста, нажмите на данное сообщение, чтобы перезагрузить эту страницу',
    },
    NOTIFICATIONS: {
      DOWNLOAD_TO_USE_ON_MOBILE: 'Загрузите приложение Telmie, чтобы использовать Telmie на своем мобильном устройстве.',
      EMAIL_VALIDATED_SUCCESSFULLY: 'Ваш e-mail адрес был успешно подтвержден. Вы можете продолжить регистрацию на своем мобильном устройстве или войти в систему, используя данные своей учетной записи на этой странице.',
      MAX_ATTACHED_FILES_AMOUNT: 'Максимальное количество вложенных файлов',
      SUPPORTED_FILE_TYPES: 'Этот формат файла еще не поддерживается. Пожалуйста, отправляйте файлы в следующих форматах:',
      UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!',
    },
    REGISTER_PRO: {
      FIRST_NAME: 'First name',
      FIRST_NAME_ERROR: 'First name field is required',
      LAST_NAME: 'Last name',
      LAST_NAME_ERROR: 'Last name field is required',
      COUNTRY: 'Country',
      COUNTRY_PLACEHOLDER: 'Select country',
      COUNTRY_ERROR: 'Country field is required',
      CITY: 'City',
      POSTCODE: 'Postcode',
      POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
      DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
      DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      MOBILE_HINT: 'We won\'t share it with others.',
      MOBILE_ERROR: 'Must contain only numbers',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
      SERVICES: 'Services',
      SERVICES_PLACEHOLDER: 'Select service',
      SERVICES_ERROR: 'Services field is required',
      SERVICE: 'Service (20 characters)',
      SERVICE_HINT: 'i.e. English practice, Immigration advice',
      SERVICE_ERROR: 'Service name may not be greater than 20 characters',
      SECTOR: 'Sector',
      SECTOR_PLACEHOLDER: 'Select sector',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
      SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
      SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
      SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
      SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
      COST_PER_MINUTE_ERROR: 'Please enter price',
      COST_PER_MINUTE_MAX: 'Maximum allowed for this service',
    },
  },
  [IT]: {
    DOWNLOAD_APP_BTN: 'Scarica la App',
    HOMEPAGE_FAQ_TITLE: 'Domande più popolari',
    GENERAL_QUESTIONS: 'Domande frequenti',
    CUSTOMERS_QUESTIONS: 'Clienti',
    EXPERTS_QUESTIONS: 'Domande frequenti per specialisti',
    PAYMENTS_QUESTIONS: 'Domande frequenti sui pagamenti',
    BLOG_TITLE: 'Blog',
    FULL_STORY_BTN: 'La storia completa',
    OTHER_POSTS: 'Altri post',
    MISC: {
      DELETE: 'Delete',
      UPDATE_NOW: 'Update now',
      CONNECTING: 'Connecting',
      CONNECTING_TO_SERVER: 'Connecting to server',
      CALLING_PRO: 'Calling Pro',
      CREDIT_CARD: 'Credit card',
      ADD_A_CARD: 'Add a card',
      SUBMIT: 'Submit',
      EMAIL: 'Email',
      SAVE: 'Save',
      OK: 'OK',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
      PLEASE_ENTER_LAST_NAME: 'Please enter last name',
      YOU_WILL_PAY: 'You will pay',
      PER_MINUTE_FOR_CALL: 'per minute for this call',
      MINUTES_SHORT: 'min',
      BECOME_PRO: 'Become a Pro',
      BLOG: 'Blog',
      FIND_A_PRO: 'Find a Pro',
      MY_CLIENTS: 'My Clients',
      MY_PROS: 'My Pros',
      MY_APPOINTMENTS: 'My Appointments',
      SIGN_UP: 'Sign Up',
      LOG_OUT: 'Log out',
      REGISTER_AS_PRO: 'Register as Pro',
      REGISTER: 'Register',
      LOG_IN: 'Log in',
      FORGOT_PASSWORD: 'Forgot password',
      PASSWORD: 'Password',
      DATE: 'Date',
      DATE_AND_TIME: 'Date and time',
      DURATION: 'Duration',
      TYPE: 'Type',
      EDIT: 'Edit',
      NAME: 'Name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      MOBILE: 'Mobile',
      CITY: 'City',
      BUSINESS_NAME: 'Business name',
      COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
      COUNTRY: 'Country',
      RATE: 'Rate',
      YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
      CODE_VERIFIED: 'Code verified',
      IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
      CODE_EXPIRES_IN: 'Code expires in',
      CODE: 'Code',
      VERIFY_CODE: 'Verify code',
      PLEASE_ENTER_EMAIL: 'Please enter email',
      RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
      SEND_VERIFICATION_CODE: 'Send verification code',
      LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully',
    },
    BLOG: {
      COMMENTS: 'Comments',
      REPLY: 'Reply',
      ADD_COMMENT: 'Add Comment',
      POST_COMMENT: 'Post comment',
    },
    BOOKING: {
      CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
      CANCELLATION_POLICY: 'Cancellation Policy',
      CANCEL_APPOINTMENT: 'Cancel Appointment',
      PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
      YES_CANCEL: 'Yes, cancel',
      NO_KEEP: 'No, keep it',
    },
    COMMUNICATION: {
      ON_CALL_WITH: 'On call with',
      CONNECTING_WITH: 'Connecting with',
      INCOMING_CALL: 'Incoming Call',
      YOUR_CLIENT: 'Your client',
      TYPE_YOUR_MESSAGE: 'Type your message',
      MIN: 'min',
      CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.',
    },
    CREDIT_CARD: {
      CARD_NUMBER: 'Card number',
      CARD_HOLDER: 'Card holder',
      EXPIRY_DATE: 'Expiry date',
      CVV: 'CVV',
      CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
      SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
      SAVE_PAYMENT_METHOD: 'Save payment method',
      X2_BONUS: 'x2 BONUS',
      YOU_WILL_GET: 'You will get',
      TELMIE_CREDIT: 'Telmie credit',
      IN_TOTAL: 'in total',
      CONFIRM_AND_PAY: 'Confirm & Pay',
      CANNOT_WITHDRAW: 'Cannot withdraw',
      FEE: 'fee',
      FREE: 'Free',
      YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
      AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
      AVALIABLE: 'Available',
      AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
      WITHDRAW: 'Withdraw',
      FREE_APPLIES: 'Fee applies: ',
      YOU_RECEIVE: 'You receive: ',
      WITHDRAWAL_RULES: 'Withdrawal rules',
      WITHDRAWAL_AMOUNT: 'Withdrawal amount',
      HIDE: 'Hide',
      SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules',
    },
    EDIT_PROFILE: {
      SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
      CANT_BE_CHANGED: 'Can\'t be changed',
      UPLOAD_PICTURE: 'Upload picture',
      NAME_ISNT_VALID: 'The name isn\'t valid.',
    },
    FEATURED_SERVICE: {
      CALL_NOW: 'Call now',
      CANCEL_CALL: 'Cancel call',
      NEXT_PRO: 'Next pro',
      NEXT_PRO_CAPS: 'NEXT PRO',
      THEN_CAPS: 'THEN',
    },
    HEADER: {
      HOW_IT_WORKS: 'Come funziona',
      FAQ: 'Domande frequenti',
      CONTACT: 'Contatti',
      MONEY: 'Money',
      SETTINGS: 'Settings',
      LOGIN: 'Log in',
      EDIT_PROFILE: 'Edit Profile',
      NEW_CHATS: 'New Chats',
      WELL_DONE: 'Well done',
      SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
      EDIT_PRO_DETAILS: 'Edit Pro details',
    },
    HOMEPAGE: {
      FEATURED_PROS: 'Featured Pros',
      FEATURED_SERVICES: 'Featured services',
      DOWNLOAD_TELMIE_APP: 'Download Telmie app',
    },
    LANGUAGE_PRACTICE: {
      HAPPY_PROS: 'Happy Pros',
      HAPPY_USERS: 'Happy Users',
    },
    LOG_IN: {
      LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
      NEW_TO_TELMIE: 'New to Telmie',
      DOWNLOAD_THE_APP: 'Download the app',
    },
    NEW_LANDING: {
      MINUTES: 'minutes',
      COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
      BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
      PLEASE_ENTER_SUBJECT: 'Please enter subject',
      PLEASE_ENTER_MESSAGE: 'Please enter message',
    },
    PRO: {
      PRO: 'Pro',
      AMOUNT: 'Amount',
      NO_RECENT_CALLS: 'No recent calls',
      MESSAGES: 'Messages',
      START_CALL: 'Start Call',
      SHORTLISTED: 'Shortlisted',
      REMOVE: 'Remove',
      SHORTLIST: 'Shortlist',
      LOADING: 'Loading',
      TELMIE_CLIENT: 'Telmie Client',
      ON_CALL: 'On call',
      RECONNECTING: 'Reconnecting...',
      TELMIE_USER_IS_CALLING: 'Telmie user is calling',
      SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
      HOURS_FIRST_LETTER: 'h',
      MINUTES_FIRST_LETTER: 'm',
      CALENDAR_TITLE: 'My availability',
      CALENDAR_SUB_TITLE: 'I am not available right now',
      CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
      AVAILABLE_NOW: 'Available now',
      AVAILABLE_LATTER: 'Available later',
      WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
      PRO_IS_BUSY: 'Pro is busy',
    },
    PROFILE: {
      VIEW_ALL: 'View all',
      CONTACT: 'Contact',
      COUNT: 'Count',
      NO_RECENT_ACTIVITY: 'No recent activity',
      YOUR_DETAILS: 'Your details',
      LOCATION: 'Location',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      NO_RECENT_PROS: 'No recent PROS',
      WITHDRAW_EARNINGS: 'Withdraw earnings',
      TOP_UP: 'Top Up',
      ATTACH_CARD: 'Attach card',
      SERVICE: 'Service',
      APPOINTMENT_WITH: 'Appointment with',
      COST: 'Cost',
      BALANCE: 'Balance',
      NO_RECENT_TRANSACTIONS: 'No recent transactions',
      NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
      CLIENT: 'Client',
    },
    RADIO_BUTTONS: {
      APPROVED: 'Approved',
      SECTORS: 'SECTORS',
    },
    SEARCH: {
      FILTERS: 'Filters',
      SESSIONS: 'sessions',
      ARRANGE_BY: 'Arrange by',
      ENTER_KEYWORDS: 'Enter keywords',
      RESET_FILTERS: 'Clear all',
    },
    SELECT: {
      EVERY: 'Every',
    },
    SETTINGS: {
      IMPORTANT_VIA_EMAIL: 'Important via email',
      WORKING_AS_PRO: 'Working as Pro',
      PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
      ADD_NEW_PERIOD: 'Add new period',
      CHANGE_BANK_ACCOUNT: 'Change bank account',
      ADD_BANK_ACCOUNT: 'Add bank account',
      ENTITY: 'Entity',
      ADDRESS: 'Address',
      YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
      WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
      SORT_CODE: 'Sort code',
      DIGITS_VALUE: 'digits value',
      ACCOUNT_NUMBER: 'Account number',
      BAD_REQUEST_DATA: 'Bad Request data',
      PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
      CONFIRM: 'Confirm',
      UPLOAD_ANOTHER_IMAGE: 'Upload another image',
      UPLOAD: 'Upload',
      YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
      YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
      PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
      POST_CODE: 'Post Code',
      LOADING_CARDS: 'Loading cards',
      NO_CARDS: 'No cards.',
      COMPANY_ADDRESS: 'Company address',
      PERSONAL_ADDRESS: 'Personal address',
      SERVICE_NAME: 'Service name',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_SUB_CATEGORY: 'Service sub-category',
      SERVICE_DESCRIPTION: 'Service description',
      PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
      LOADING_ACCOUNTS: 'Loading accounts',
      ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
      PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
      THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
      DAYS_REQUIRED: 'Please select days',
      FROM: 'From',
      TO: 'To',
      COMPANY: 'Company',
      INDIVIDUAL: 'Individual',
      PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
      PROFILE_DETAILS: 'Profile details',
      PRO_SETTINGS: 'PRO SETTINGS',
      WORK_AS_PRO: 'Work as Pro',
      PRO_DETAILS: 'Pro details',
      PAYOUT_BANK_DETAILS: 'Payout bank details',
      PREVIEW_MY_PROFILE: 'Preview my profile',
      MY_AVAILABILITY: 'My availability',
      HIDE_PROFILE: 'Hide profile',
      GENERAL_SETTINGS: 'GENERAL SETTINGS',
      PAYMENT_SETTINGS: 'Payment settings',
      EMAIL_NOTIFICATION: 'Email notification',
      BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
      BANK_ACCOUNT: 'Bank account',
      ID_VERIFICATION: 'ID Verification',
      I_WANT_TO_TAKE_PART: 'I want to take part',
    },
    SIGN_UP: {
      CONFIRM_EMAIL: 'Now confirm your email address',
      RESEND: 'Resend',
      CONFIRM_EMAIL_MESSAGE: (email) => <span>We've sent an email to {email}, please check your inbox and click the link 'Activate' to confirm and earn!</span>,
      USE_ANOTHER_EMAIL: 'Use another email',
      SECTOR: 'Sector',
      CATEGORY: 'Category',
      PLEASE_SELECT_CATEGORY: 'Please select category',
      PROFESSION: 'Profession',
      DESCRIPTION: 'Description',
      FREE: 'Free',
      PER_MINUTE: 'per minute',
      BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
      TERMS_OF_USE: 'Terms of use',
      AND_THE: 'and the',
      PRIVACY_POLICY: 'Privacy Policy',
      THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
      CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
      ACCOUNT_TYPE: 'Account type',
      APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
      CANCEL_CHANGES: 'Cancel changes',
      PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
      ERROR: 'Error',
      PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
      UNITED_KINGDOM: 'United Kingdom',
      ONLY_UK_NOW: 'Only UK for now',
      I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
      ALREADY_HAVE_ACCOUNT: 'Already have an account',
      CODE_HAVE_BEEN_SENT: 'Code has been sent to',
      EDUCATION: {
        EDUCATION: 'Education',
        LANGUAGE_TUTOR: 'Language tutor',
        LANGUAGE_PRACTICE: 'Language practice',
        EXAMS_PREPARATION: 'Exams preparation',
        SCIENCE: 'Science',
        BUSINESS_STUDIES: 'Business studies',
        SOCIAL_SCIENCE: 'Social science',
        DRAWING: 'Drawing',
        MUSIC: 'Music',
        DANCE: 'Dance',
      },
      SERVICES: {
        SERVICES: 'Services',
        INTERPRETER: 'Interpreter',
        NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
        THERAPIST: 'Therapist',
        LISTENER: 'Listener',
        SPEECH_THERAPIST: 'Speech therapist',
        FORTUN_TELLER: 'Fortun teller',
        ASTROLOGIST: 'Astrologist',
        PERSONAL_ASSISTANT: 'Personal assistant',
        CAREER_COACH: 'Career coach',
      },
      CONSULTANCY: {
        CONSULTANCY: 'Consultancy',
        LEGAL: 'Legal',
        MEDICAL: 'Medical',
        BUSINESS: 'Business',
        FAMILY: 'Family',
        INVESTMENT: 'Investment',
        TECH_SUPPORT: 'Tech support',
        BEAUTICIAN: 'Beautician',
      },
      HEALTH_LIFESTYLE: {
        HEALTH_LIFESTYLE: 'Health&Lifestyle',
        PERSONAL_TRAINER: 'Personal trainer',
        YOGA_INSTRUCTOR: 'Yuga instructor',
        MEDITATION_INSTRUCTOR: 'Meditation instructor',
        DIETOLOGIST: 'Dietologist',
        SPORT_COACH: 'Sport coach',
        FITNESS_PROFESSIONAL: 'Fitness professional',
        SPIRITUAL_COACH: 'Spiritual coach',
      },
      PLEASE_SELECT_SECTOR: 'Please select sector',
      PLEASE_ENTER_PROFESSION: 'Please enter profession',
      PLEASE_ENTER_DESCRIPTION: 'Please enter description',
      PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
      PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
      YOU_ARE_UNDER_18: 'You are under 18',
      DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
      YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
      PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
      CITY_IN_THE_UK: 'City in the UK',
      CITY_INCORRECT: 'City incorrect',
      POSTCODE: 'Postcode',
      PLEASE_ENTER_POSTCODE: 'Please enter postcode',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      ONLY_UK_ADDRESS: 'Only UK address',
      ADDRESS_INCORRECT: 'Address incorrect',
      ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
      BIRTHDAY_INCORRECT: 'Birthday incorrect',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      WE_WONT_SHARE_IT: 'We won\'t share it with others.',
      MOBILE_INCORRECT: 'Mobile incorrect',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      EG_IO: 'e.g. i0ONOZLgCIM',
      SERVICE_INCORRECT: 'Service incorrect',
      SERVICE_LABEL: 'Service (20 characters)',
      IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
      SERVICE_NAME_INCORRECT: 'Service name incorrect',
      SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
      SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
      SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
      PRICE_PER_MINUTE: 'Price per minute',
      DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
      YES: 'Yes.',
      NO: 'No.',
      DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
      YES_SAVE: 'Yes, save.',
      DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
      ENTER_TAX_ID: 'Enter tax ID to check',
      CHECK: 'Check.',
      PLEASE_ENTER_PASSWORD: 'Please enter password',
      FIRST_NAME: 'First name',
    },
    SOCIAL_NETWORK: {
      CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
      CONTINUE_WITH_GOOGLE: 'Continue with Google',
    },
    ROUTES: {
      ERROR_404: 'Error 404',
      PAGE_NOT_FOUND: 'Page not found',
      THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
      GO_HOME: 'Go Home',
      FEATURED_SERVICE: 'FEATURED SERVICE',
      WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
      GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
      FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
      CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
      NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
      YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
      RESET: 'Reset',
      BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
      TELMIE_T_C: 'Telmie T&C',
      TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
      AND: 'and',
      STRIPE_T_C: 'Stripe T&C.',
      SORRY: 'Sorry',
      IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
      OR: 'or',
      IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
      BACK_TO_SETTINGS: 'Back to Settings',
      PROFILE_PREVIEW: 'Profile preview',
      PRO_DETAILS: 'Pro details',
      PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
      RESULTS_FOR: 'Results for',
      SORRY_NO_PROS: 'Sorry, no pros found for',
      SELECT_YOUR_INTEREST: 'Select your interest',
      TELMIE_MY_CLIENTS: 'Telmie | My Clients',
      FIND_YOUR_CLIENT: 'Find your Client',
      TELMIE_MY_PROS: 'Telmie | My Pros',
      FIND_YOUR_PRO: 'Find your Pro',
      PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
      TELMIE_PREVIEW: 'Telmie | Preview',
      LOWEST_RATE_FIRST: 'Lowest rate first',
      HIGHEST_RATE_FIRST: 'Highest rate first',
      EXPERIENCE: 'Experience',
      RATING: 'Rating',
      ACTIVITY: 'Activity',
      LANGUAGES: 'Languages',
      COACHING: 'Coaching',
      IMMIGRATION: 'Immigration',
      OTHER: 'Other',
      ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
      ERROR_WITH_STRIPE: 'Error with Stripe.',
      TELMIE_PRO: 'Telmie | Pro',
    },
    FOOTER: {
      HOME: 'Home',
      CONTACT: 'Contatti',
      SUPPORT: 'Support',
      POLICY: 'Privacy Policy',
      TERMS: 'Termini e condizioni',
      FAQ: 'Domande frequenti',
      COPYRIGHT: 'Copyright',
      COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom',
    },
    CONTACT_US: {
      title: 'Contatti',
      subTitle: 'Hai qualche domanda? ',
      name: 'Nome',
      email: 'E-mail',
      company: 'Azienda',
      subject: 'Oggetto',
      message: 'Scrivi qui il tuo messaggio',
      success: 'Grazie per averci contattato ',
      submitBtn: 'Invia',
    },
    SERVICES: {
      LANGUAGE_PRACTICE: 'Esercizio delle lingue straniere',
      IMMIGRATION_ADVICE: 'Consulenza immigrazione',
      IMMIGRATION_CONSULTANT: 'Consulente in immigrazione',
      LANGUAGE_LEARNERS: 'Impara la lingua',
    },
    FAQ: 'Domande frequenti',
    MORE_FAQ: 'Altre domande',
    API: {
      NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content',
    },
    NOTIFICATIONS: {
      DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
      EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
      MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
      SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
      UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!',
    },
    REGISTER_PRO: {
      FIRST_NAME: 'First name',
      FIRST_NAME_ERROR: 'First name field is required',
      LAST_NAME: 'Last name',
      LAST_NAME_ERROR: 'Last name field is required',
      COUNTRY: 'Country',
      COUNTRY_PLACEHOLDER: 'Select country',
      COUNTRY_ERROR: 'Country field is required',
      CITY: 'City',
      POSTCODE: 'Postcode',
      POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
      DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
      DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      MOBILE_HINT: 'We won\'t share it with others.',
      MOBILE_ERROR: 'Must contain only numbers',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
      SERVICES: 'Services',
      SERVICES_PLACEHOLDER: 'Select service',
      SERVICES_ERROR: 'Services field is required',
      SERVICE: 'Service (20 characters)',
      SERVICE_HINT: 'i.e. English practice, Immigration advice',
      SERVICE_ERROR: 'Service name may not be greater than 20 characters',
      SECTOR: 'Sector',
      SECTOR_PLACEHOLDER: 'Select sector',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
      SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
      SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
      SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
      SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
      COST_PER_MINUTE_ERROR: 'Please enter price',
      COST_PER_MINUTE_MAX: 'Maximum allowed for this service',
    },
  },
  [ES]: {
    DOWNLOAD_APP_BTN: 'Descarga nuestra app',
    HOMEPAGE_FAQ_TITLE: 'Preguntas más populares',
    GENERAL_QUESTIONS: 'Preguntas Frecuentes',
    CUSTOMERS_QUESTIONS: 'Clientes',
    EXPERTS_QUESTIONS: 'Preguntas Frecuentes sobre Expertos',
    PAYMENTS_QUESTIONS: 'Preguntas sobre Pagos',
    BLOG_TITLE: 'Blog',
    FULL_STORY_BTN: 'Leer Más',
    OTHER_POSTS: 'Otros articulos',
    MISC: {
      DELETE: 'Delete',
      UPDATE_NOW: 'Update now',
      CONNECTING: 'Connecting',
      CONNECTING_TO_SERVER: 'Connecting to server',
      CALLING_PRO: 'Calling Pro',
      CREDIT_CARD: 'Credit card',
      ADD_A_CARD: 'Add a card',
      SUBMIT: 'Submit',
      EMAIL: 'Email',
      SAVE: 'Save',
      OK: 'OK',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
      PLEASE_ENTER_LAST_NAME: 'Please enter last name',
      YOU_WILL_PAY: 'You will pay',
      PER_MINUTE_FOR_CALL: 'per minute for this call',
      MINUTES_SHORT: 'min',
      BECOME_PRO: 'Conviértete en Pro',
      BLOG: 'Blog',
      FIND_A_PRO: 'Find a Pro',
      MY_CLIENTS: 'My Clients',
      MY_PROS: 'My Pros',
      MY_APPOINTMENTS: 'My Appointments',
      SIGN_UP: 'Sign Up',
      LOG_OUT: 'Log out',
      REGISTER_AS_PRO: 'Register as Pro',
      REGISTER: 'Register',
      LOG_IN: 'Log in',
      FORGOT_PASSWORD: 'Forgot password',
      PASSWORD: 'Password',
      DATE: 'Date',
      DATE_AND_TIME: 'Date and time',
      DURATION: 'Duration',
      TYPE: 'Type',
      EDIT: 'Edit',
      NAME: 'Name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      MOBILE: 'Mobile',
      CITY: 'City',
      BUSINESS_NAME: 'Business name',
      COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
      COUNTRY: 'Country',
      RATE: 'Rate',
      YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
      CODE_VERIFIED: 'Code verified',
      IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
      CODE_EXPIRES_IN: 'Code expires in',
      CODE: 'Code',
      VERIFY_CODE: 'Verify code',
      PLEASE_ENTER_EMAIL: 'Please enter email',
      RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
      SEND_VERIFICATION_CODE: 'Send verification code',
      LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully',
    },
    BLOG: {
      COMMENTS: 'Comments',
      REPLY: 'Reply',
      ADD_COMMENT: 'Add Comment',
      POST_COMMENT: 'Post comment',
    },
    BOOKING: {
      CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
      CANCELLATION_POLICY: 'Cancellation Policy',
      CANCEL_APPOINTMENT: 'Cancel Appointment',
      PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
      YES_CANCEL: 'Yes, cancel',
      NO_KEEP: 'No, keep it',
    },
    COMMUNICATION: {
      ON_CALL_WITH: 'On call with',
      CONNECTING_WITH: 'Connecting with',
      INCOMING_CALL: 'Incoming Call',
      YOUR_CLIENT: 'Your client',
      TYPE_YOUR_MESSAGE: 'Type your message',
      MIN: 'min',
      CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.',
    },
    CREDIT_CARD: {
      CARD_NUMBER: 'Card number',
      CARD_HOLDER: 'Card holder',
      EXPIRY_DATE: 'Expiry date',
      CVV: 'CVV',
      CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
      SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
      SAVE_PAYMENT_METHOD: 'Save payment method',
      X2_BONUS: 'x2 BONUS',
      YOU_WILL_GET: 'You will get',
      TELMIE_CREDIT: 'Telmie credit',
      IN_TOTAL: 'in total',
      CONFIRM_AND_PAY: 'Confirm & Pay',
      CANNOT_WITHDRAW: 'Cannot withdraw',
      FEE: 'fee',
      FREE: 'Free',
      YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
      AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
      AVALIABLE: 'Available',
      AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
      WITHDRAW: 'Withdraw',
      FREE_APPLIES: 'Fee applies: ',
      YOU_RECEIVE: 'You receive: ',
      WITHDRAWAL_RULES: 'Withdrawal rules',
      WITHDRAWAL_AMOUNT: 'Withdrawal amount',
      HIDE: 'Hide',
      SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules',
    },
    EDIT_PROFILE: {
      SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
      CANT_BE_CHANGED: 'Can\'t be changed',
      UPLOAD_PICTURE: 'Upload picture',
      NAME_ISNT_VALID: 'The name isn\'t valid.',
    },
    FEATURED_SERVICE: {
      CALL_NOW: 'Call now',
      CANCEL_CALL: 'Cancel call',
      NEXT_PRO: 'Next pro',
      NEXT_PRO_CAPS: 'NEXT PRO',
      THEN_CAPS: 'THEN',
    },
    HEADER: {
      HOW_IT_WORKS: 'Cómo funciona',
      FAQ: 'FAQs',
      CONTACT: 'Contacto',
      MONEY: 'Money',
      SETTINGS: 'Settings',
      LOGIN: 'Log in',
      EDIT_PROFILE: 'Edit Profile',
      NEW_CHATS: 'New Chats',
      WELL_DONE: 'Well done',
      SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
      EDIT_PRO_DETAILS: 'Edit Pro details',
    },
    HOMEPAGE: {
      FEATURED_PROS: 'Featured Pros',
      FEATURED_SERVICES: 'Featured services',
      DOWNLOAD_TELMIE_APP: 'Download Telmie app',
    },
    LANGUAGE_PRACTICE: {
      HAPPY_PROS: 'Happy Pros',
      HAPPY_USERS: 'Happy Users',
    },
    LOG_IN: {
      LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
      NEW_TO_TELMIE: 'New to Telmie',
      DOWNLOAD_THE_APP: 'Download the app',
    },
    NEW_LANDING: {
      MINUTES: 'minutes',
      COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
      BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
      PLEASE_ENTER_SUBJECT: 'Please enter subject',
      PLEASE_ENTER_MESSAGE: 'Please enter message',
    },
    PRO: {
      PRO: 'Pro',
      AMOUNT: 'Amount',
      NO_RECENT_CALLS: 'No recent calls',
      MESSAGES: 'Messages',
      START_CALL: 'Start Call',
      SHORTLISTED: 'Shortlisted',
      REMOVE: 'Remove',
      SHORTLIST: 'Shortlist',
      LOADING: 'Loading',
      TELMIE_CLIENT: 'Telmie Client',
      ON_CALL: 'On call',
      RECONNECTING: 'Reconnecting...',
      TELMIE_USER_IS_CALLING: 'Telmie user is calling',
      SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
      HOURS_FIRST_LETTER: 'h',
      MINUTES_FIRST_LETTER: 'm',
      CALENDAR_TITLE: 'My availability',
      CALENDAR_SUB_TITLE: 'I am not available right now',
      CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
      AVAILABLE_NOW: 'Available now',
      AVAILABLE_LATTER: 'Available later',
      WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
      PRO_IS_BUSY: 'Pro is busy',
    },
    PROFILE: {
      VIEW_ALL: 'View all',
      CONTACT: 'Contact',
      COUNT: 'Count',
      NO_RECENT_ACTIVITY: 'No recent activity',
      YOUR_DETAILS: 'Your details',
      LOCATION: 'Location',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      NO_RECENT_PROS: 'No recent PROS',
      WITHDRAW_EARNINGS: 'Withdraw earnings',
      TOP_UP: 'Top Up',
      ATTACH_CARD: 'Attach card',
      SERVICE: 'Service',
      APPOINTMENT_WITH: 'Appointment with',
      COST: 'Cost',
      BALANCE: 'Balance',
      NO_RECENT_TRANSACTIONS: 'No recent transactions',
      NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
      CLIENT: 'Client',
    },
    RADIO_BUTTONS: {
      APPROVED: 'Approved',
      SECTORS: 'SECTORS',
    },
    SEARCH: {
      FILTERS: 'Filters',
      SESSIONS: 'sessions',
      ARRANGE_BY: 'Arrange by',
      ENTER_KEYWORDS: 'Enter keywords',
      RESET_FILTERS: 'Clear all',
    },
    SELECT: {
      EVERY: 'Every',
    },
    SETTINGS: {
      IMPORTANT_VIA_EMAIL: 'Important via email',
      WORKING_AS_PRO: 'Working as Pro',
      PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
      ADD_NEW_PERIOD: 'Add new period',
      CHANGE_BANK_ACCOUNT: 'Change bank account',
      ADD_BANK_ACCOUNT: 'Add bank account',
      ENTITY: 'Entity',
      ADDRESS: 'Address',
      YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
      WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
      SORT_CODE: 'Sort code',
      DIGITS_VALUE: 'digits value',
      ACCOUNT_NUMBER: 'Account number',
      BAD_REQUEST_DATA: 'Bad Request data',
      PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
      CONFIRM: 'Confirm',
      UPLOAD_ANOTHER_IMAGE: 'Upload another image',
      UPLOAD: 'Upload',
      YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
      YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
      PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
      POST_CODE: 'Post Code',
      LOADING_CARDS: 'Loading cards',
      NO_CARDS: 'No cards.',
      COMPANY_ADDRESS: 'Company address',
      PERSONAL_ADDRESS: 'Personal address',
      SERVICE_NAME: 'Service name',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_SUB_CATEGORY: 'Service sub-category',
      SERVICE_DESCRIPTION: 'Service description',
      PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
      LOADING_ACCOUNTS: 'Loading accounts',
      ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
      PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
      THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
      DAYS_REQUIRED: 'Please select days',
      FROM: 'From',
      TO: 'To',
      COMPANY: 'Company',
      INDIVIDUAL: 'Individual',
      PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
      PROFILE_DETAILS: 'Profile details',
      PRO_SETTINGS: 'PRO SETTINGS',
      WORK_AS_PRO: 'Work as Pro',
      PRO_DETAILS: 'Pro details',
      PAYOUT_BANK_DETAILS: 'Payout bank details',
      PREVIEW_MY_PROFILE: 'Preview my profile',
      MY_AVAILABILITY: 'My availability',
      HIDE_PROFILE: 'Hide profile',
      GENERAL_SETTINGS: 'GENERAL SETTINGS',
      PAYMENT_SETTINGS: 'Payment settings',
      EMAIL_NOTIFICATION: 'Email notification',
      BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
      BANK_ACCOUNT: 'Bank account',
      ID_VERIFICATION: 'ID Verification',
      I_WANT_TO_TAKE_PART: 'I want to take part',
    },
    SIGN_UP: {
      CONFIRM_EMAIL: 'Now confirm your email address',
      RESEND: 'Resend',
      CONFIRM_EMAIL_MESSAGE: (email) => <span>We've sent an email to {email}, please check your inbox and click the link 'Activate' to confirm and earn!</span>,
      USE_ANOTHER_EMAIL: 'Use another email',
      SECTOR: 'Sector',
      CATEGORY: 'Category',
      PLEASE_SELECT_CATEGORY: 'Please select category',
      PROFESSION: 'Profession',
      DESCRIPTION: 'Description',
      FREE: 'Free',
      PER_MINUTE: 'per minute',
      BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
      TERMS_OF_USE: 'Terms of use',
      AND_THE: 'and the',
      PRIVACY_POLICY: 'Privacy Policy',
      THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
      CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
      ACCOUNT_TYPE: 'Account type',
      APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
      CANCEL_CHANGES: 'Cancel changes',
      PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
      ERROR: 'Error',
      PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
      UNITED_KINGDOM: 'United Kingdom',
      ONLY_UK_NOW: 'Only UK for now',
      I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
      ALREADY_HAVE_ACCOUNT: 'Already have an account',
      CODE_HAVE_BEEN_SENT: 'Code has been sent to',
      EDUCATION: {
        EDUCATION: 'Education',
        LANGUAGE_TUTOR: 'Language tutor',
        LANGUAGE_PRACTICE: 'Language practice',
        EXAMS_PREPARATION: 'Exams preparation',
        SCIENCE: 'Science',
        BUSINESS_STUDIES: 'Business studies',
        SOCIAL_SCIENCE: 'Social science',
        DRAWING: 'Drawing',
        MUSIC: 'Music',
        DANCE: 'Dance',
      },
      SERVICES: {
        SERVICES: 'Services',
        INTERPRETER: 'Interpreter',
        NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
        THERAPIST: 'Therapist',
        LISTENER: 'Listener',
        SPEECH_THERAPIST: 'Speech therapist',
        FORTUN_TELLER: 'Fortun teller',
        ASTROLOGIST: 'Astrologist',
        PERSONAL_ASSISTANT: 'Personal assistant',
        CAREER_COACH: 'Career coach',
      },
      CONSULTANCY: {
        CONSULTANCY: 'Consultancy',
        LEGAL: 'Legal',
        MEDICAL: 'Medical',
        BUSINESS: 'Business',
        FAMILY: 'Family',
        INVESTMENT: 'Investment',
        TECH_SUPPORT: 'Tech support',
        BEAUTICIAN: 'Beautician',
      },
      HEALTH_LIFESTYLE: {
        HEALTH_LIFESTYLE: 'Health&Lifestyle',
        PERSONAL_TRAINER: 'Personal trainer',
        YOGA_INSTRUCTOR: 'Yuga instructor',
        MEDITATION_INSTRUCTOR: 'Meditation instructor',
        DIETOLOGIST: 'Dietologist',
        SPORT_COACH: 'Sport coach',
        FITNESS_PROFESSIONAL: 'Fitness professional',
        SPIRITUAL_COACH: 'Spiritual coach',
      },
      PLEASE_SELECT_SECTOR: 'Please select sector',
      PLEASE_ENTER_PROFESSION: 'Please enter profession',
      PLEASE_ENTER_DESCRIPTION: 'Please enter description',
      PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
      PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
      YOU_ARE_UNDER_18: 'You are under 18',
      DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
      YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
      PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
      CITY_IN_THE_UK: 'City in the UK',
      CITY_INCORRECT: 'City incorrect',
      POSTCODE: 'Postcode',
      PLEASE_ENTER_POSTCODE: 'Please enter postcode',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      ONLY_UK_ADDRESS: 'Only UK address',
      ADDRESS_INCORRECT: 'Address incorrect',
      ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
      BIRTHDAY_INCORRECT: 'Birthday incorrect',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      WE_WONT_SHARE_IT: 'We won\'t share it with others.',
      MOBILE_INCORRECT: 'Mobile incorrect',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      EG_IO: 'e.g. i0ONOZLgCIM',
      SERVICE_INCORRECT: 'Service incorrect',
      SERVICE_LABEL: 'Service (20 characters)',
      IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
      SERVICE_NAME_INCORRECT: 'Service name incorrect',
      SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
      SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
      SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
      PRICE_PER_MINUTE: 'Price per minute',
      DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
      YES: 'Yes.',
      NO: 'No.',
      DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
      YES_SAVE: 'Yes, save.',
      DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
      ENTER_TAX_ID: 'Enter tax ID to check',
      CHECK: 'Check.',
      PLEASE_ENTER_PASSWORD: 'Please enter password',
      FIRST_NAME: 'First name',
    },
    SOCIAL_NETWORK: {
      CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
      CONTINUE_WITH_GOOGLE: 'Continue with Google',
    },
    ROUTES: {
      ERROR_404: 'Error 404',
      PAGE_NOT_FOUND: 'Page not found',
      THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
      GO_HOME: 'Go Home',
      FEATURED_SERVICE: 'FEATURED SERVICE',
      WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
      GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
      FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
      CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
      NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
      YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
      RESET: 'Reset',
      BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
      TELMIE_T_C: 'Telmie T&C',
      TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
      AND: 'and',
      STRIPE_T_C: 'Stripe T&C.',
      SORRY: 'Sorry',
      IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
      OR: 'or',
      IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
      BACK_TO_SETTINGS: 'Back to Settings',
      PROFILE_PREVIEW: 'Profile preview',
      PRO_DETAILS: 'Pro details',
      PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
      RESULTS_FOR: 'Results for',
      SORRY_NO_PROS: 'Sorry, no pros found for',
      SELECT_YOUR_INTEREST: 'Select your interest',
      TELMIE_MY_CLIENTS: 'Telmie | My Clients',
      FIND_YOUR_CLIENT: 'Find your Client',
      TELMIE_MY_PROS: 'Telmie | My Pros',
      FIND_YOUR_PRO: 'Find your Pro',
      PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
      TELMIE_PREVIEW: 'Telmie | Preview',
      LOWEST_RATE_FIRST: 'Lowest rate first',
      HIGHEST_RATE_FIRST: 'Highest rate first',
      EXPERIENCE: 'Experience',
      RATING: 'Rating',
      ACTIVITY: 'Activity',
      LANGUAGES: 'Languages',
      COACHING: 'Coaching',
      IMMIGRATION: 'Immigration',
      OTHER: 'Other',
      ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
      ERROR_WITH_STRIPE: 'Error with Stripe.',
      TELMIE_PRO: 'Telmie | Pro',
    },
    FOOTER: {
      HOME: 'Inicio',
      CONTACT: 'Contacto',
      POLICY: 'Política de Privacidad',
      SUPPORT: 'Support',
      TERMS: 'Términos de Uso',
      FAQ: 'FAQs',
      COPYRIGHT: 'Copyright',
      COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom',
    },
    CONTACT_US: {
      title: 'Contacto',
      subTitle: '¿Tienes dudas? Escríbenos',
      name: 'Nombre',
      email: 'Correo electrónico',
      company: 'Empresa',
      subject: 'Asunto',
      message: 'Escribe tu mensaje',
      success: 'Gracias por contactarnos',
      submitBtn: 'Enviar',
    },
    SERVICES: {
      LANGUAGE_PRACTICE: 'Practicar Idiomas',
      IMMIGRATION_ADVICE: 'Trámites de Inmigración',
      IMMIGRATION_CONSULTANT: 'Trámites de Inmigración',
      LANGUAGE_LEARNERS: 'Aprender idiomas',
    },
    FAQ: 'FAQs',
    MORE_FAQ: 'Más Preguntas Frecuentes',
  },
  [PL]: {
    DOWNLOAD_APP_BTN: 'Ściągnij aplikację',
    HOMEPAGE_FAQ_TITLE: 'Najpopularniejsze pytania',
    GENERAL_QUESTIONS: 'Ogólne pytania',
    CUSTOMERS_QUESTIONS: 'Klienci',
    EXPERTS_QUESTIONS: 'Ekspert',
    PAYMENTS_QUESTIONS: 'Płatności',
    BLOG_TITLE: 'Blog',
    FULL_STORY_BTN: 'Pełna historia',
    OTHER_POSTS: 'Inne',
    MISC: {
      DELETE: 'Delete',
      UPDATE_NOW: 'Update now',
      CONNECTING: 'Connecting',
      CONNECTING_TO_SERVER: 'Connecting to server',
      CALLING_PRO: 'Calling Pro',
      CREDIT_CARD: 'Credit card',
      ADD_A_CARD: 'Add a card',
      SUBMIT: 'Submit',
      EMAIL: 'Email',
      SAVE: 'Save',
      OK: 'OK',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
      PLEASE_ENTER_LAST_NAME: 'Please enter last name',
      YOU_WILL_PAY: 'You will pay',
      PER_MINUTE_FOR_CALL: 'per minute for this call',
      MINUTES_SHORT: 'min',
      BECOME_PRO: 'Zostań ekspertem',
      BLOG: 'Blog',
      FIND_A_PRO: 'Find a Pro',
      MY_CLIENTS: 'My Clients',
      MY_PROS: 'My Pros',
      MY_APPOINTMENTS: 'My Appointments',
      SIGN_UP: 'Sign Up',
      LOG_OUT: 'Log out',
      REGISTER_AS_PRO: 'Register as Pro',
      REGISTER: 'Register',
      LOG_IN: 'Log in',
      FORGOT_PASSWORD: 'Forgot password',
      PASSWORD: 'Password',
      DATE: 'Date',
      DATE_AND_TIME: 'Date and time',
      DURATION: 'Duration',
      TYPE: 'Type',
      EDIT: 'Edit',
      NAME: 'Name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      MOBILE: 'Mobile',
      CITY: 'City',
      BUSINESS_NAME: 'Business name',
      COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
      COUNTRY: 'Country',
      RATE: 'Rate',
      YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
      CODE_VERIFIED: 'Code verified',
      IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
      CODE_EXPIRES_IN: 'Code expires in',
      CODE: 'Code',
      VERIFY_CODE: 'Verify code',
      PLEASE_ENTER_EMAIL: 'Please enter email',
      RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
      SEND_VERIFICATION_CODE: 'Send verification code',
      LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully',
    },
    BLOG: {
      COMMENTS: 'Comments',
      REPLY: 'Reply',
      ADD_COMMENT: 'Add Comment',
      POST_COMMENT: 'Post comment',
    },
    BOOKING: {
      CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
      CANCELLATION_POLICY: 'Cancellation Policy',
      CANCEL_APPOINTMENT: 'Cancel Appointment',
      PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
      YES_CANCEL: 'Yes, cancel',
      NO_KEEP: 'No, keep it',
    },
    COMMUNICATION: {
      ON_CALL_WITH: 'On call with',
      CONNECTING_WITH: 'Connecting with',
      INCOMING_CALL: 'Incoming Call',
      YOUR_CLIENT: 'Your client',
      TYPE_YOUR_MESSAGE: 'Type your message',
      MIN: 'min',
      CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.',
    },
    CREDIT_CARD: {
      CARD_NUMBER: 'Card number',
      CARD_HOLDER: 'Card holder',
      EXPIRY_DATE: 'Expiry date',
      CVV: 'CVV',
      CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
      SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
      SAVE_PAYMENT_METHOD: 'Save payment method',
      X2_BONUS: 'x2 BONUS',
      YOU_WILL_GET: 'You will get',
      TELMIE_CREDIT: 'Telmie credit',
      IN_TOTAL: 'in total',
      CONFIRM_AND_PAY: 'Confirm & Pay',
      CANNOT_WITHDRAW: 'Cannot withdraw',
      FEE: 'fee',
      FREE: 'Free',
      YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
      AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
      AVALIABLE: 'Available',
      AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
      WITHDRAW: 'Withdraw',
      FREE_APPLIES: 'Fee applies: ',
      YOU_RECEIVE: 'You receive: ',
      WITHDRAWAL_RULES: 'Withdrawal rules',
      WITHDRAWAL_AMOUNT: 'Withdrawal amount',
      HIDE: 'Hide',
      SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules',
    },
    EDIT_PROFILE: {
      SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
      CANT_BE_CHANGED: 'Can\'t be changed',
      UPLOAD_PICTURE: 'Upload picture',
      NAME_ISNT_VALID: 'The name isn\'t valid.',
    },
    FEATURED_SERVICE: {
      CALL_NOW: 'Call now',
      CANCEL_CALL: 'Cancel call',
      NEXT_PRO: 'Next pro',
      NEXT_PRO_CAPS: 'NEXT PRO',
      THEN_CAPS: 'THEN',
    },
    HEADER: {
      HOW_IT_WORKS: 'Jak to działa',
      FAQ: 'FAQ',
      CONTACT: 'Kontakt',
      MONEY: 'Money',
      SETTINGS: 'Settings',
      LOGIN: 'Log in',
      EDIT_PROFILE: 'Edit Profile',
      NEW_CHATS: 'New Chats',
      WELL_DONE: 'Well done',
      SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
      EDIT_PRO_DETAILS: 'Edit Pro details',
    },
    HOMEPAGE: {
      FEATURED_PROS: 'Featured Pros',
      FEATURED_SERVICES: 'Featured services',
      DOWNLOAD_TELMIE_APP: 'Download Telmie app',
    },
    LANGUAGE_PRACTICE: {
      HAPPY_PROS: 'Happy Pros',
      HAPPY_USERS: 'Happy Users',
    },
    LOG_IN: {
      LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
      NEW_TO_TELMIE: 'New to Telmie',
      DOWNLOAD_THE_APP: 'Download the app',
    },
    NEW_LANDING: {
      MINUTES: 'minutes',
      COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
      BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
      PLEASE_ENTER_SUBJECT: 'Please enter subject',
      PLEASE_ENTER_MESSAGE: 'Please enter message',
    },
    PRO: {
      PRO: 'Pro',
      AMOUNT: 'Amount',
      NO_RECENT_CALLS: 'No recent calls',
      MESSAGES: 'Messages',
      START_CALL: 'Start Call',
      SHORTLISTED: 'Shortlisted',
      REMOVE: 'Remove',
      SHORTLIST: 'Shortlist',
      LOADING: 'Loading',
      TELMIE_CLIENT: 'Telmie Client',
      ON_CALL: 'On call',
      RECONNECTING: 'Reconnecting...',
      TELMIE_USER_IS_CALLING: 'Telmie user is calling',
      SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
      HOURS_FIRST_LETTER: 'h',
      MINUTES_FIRST_LETTER: 'm',
      CALENDAR_TITLE: 'My availability',
      CALENDAR_SUB_TITLE: 'I am not available right now',
      CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
      AVAILABLE_NOW: 'Available now',
      AVAILABLE_LATTER: 'Available later',
      WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
      PRO_IS_BUSY: 'Pro is busy',
    },
    PROFILE: {
      VIEW_ALL: 'View all',
      CONTACT: 'Contact',
      COUNT: 'Count',
      NO_RECENT_ACTIVITY: 'No recent activity',
      YOUR_DETAILS: 'Your details',
      LOCATION: 'Location',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      NO_RECENT_PROS: 'No recent PROS',
      WITHDRAW_EARNINGS: 'Withdraw earnings',
      TOP_UP: 'Top Up',
      ATTACH_CARD: 'Attach card',
      SERVICE: 'Service',
      APPOINTMENT_WITH: 'Appointment with',
      COST: 'Cost',
      BALANCE: 'Balance',
      NO_RECENT_TRANSACTIONS: 'No recent transactions',
      NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
      CLIENT: 'Client',
    },
    RADIO_BUTTONS: {
      APPROVED: 'Approved',
      SECTORS: 'SECTORS',
    },
    SEARCH: {
      FILTERS: 'Filters',
      SESSIONS: 'sessions',
      ARRANGE_BY: 'Arrange by',
      ENTER_KEYWORDS: 'Enter keywords',
      RESET_FILTERS: 'Clear all',
    },
    SELECT: {
      EVERY: 'Every',
    },
    SETTINGS: {
      IMPORTANT_VIA_EMAIL: 'Important via email',
      WORKING_AS_PRO: 'Working as Pro',
      PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
      ADD_NEW_PERIOD: 'Add new period',
      CHANGE_BANK_ACCOUNT: 'Change bank account',
      ADD_BANK_ACCOUNT: 'Add bank account',
      ENTITY: 'Entity',
      ADDRESS: 'Address',
      YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
      WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
      SORT_CODE: 'Sort code',
      DIGITS_VALUE: 'digits value',
      ACCOUNT_NUMBER: 'Account number',
      BAD_REQUEST_DATA: 'Bad Request data',
      PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
      CONFIRM: 'Confirm',
      UPLOAD_ANOTHER_IMAGE: 'Upload another image',
      UPLOAD: 'Upload',
      YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
      YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
      PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
      POST_CODE: 'Post Code',
      LOADING_CARDS: 'Loading cards',
      NO_CARDS: 'No cards.',
      COMPANY_ADDRESS: 'Company address',
      PERSONAL_ADDRESS: 'Personal address',
      SERVICE_NAME: 'Service name',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_SUB_CATEGORY: 'Service sub-category',
      SERVICE_DESCRIPTION: 'Service description',
      PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
      LOADING_ACCOUNTS: 'Loading accounts',
      ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
      PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
      THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
      DAYS_REQUIRED: 'Please select days',
      FROM: 'From',
      TO: 'To',
      COMPANY: 'Company',
      INDIVIDUAL: 'Individual',
      PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
      PROFILE_DETAILS: 'Profile details',
      PRO_SETTINGS: 'PRO SETTINGS',
      WORK_AS_PRO: 'Work as Pro',
      PRO_DETAILS: 'Pro details',
      PAYOUT_BANK_DETAILS: 'Payout bank details',
      PREVIEW_MY_PROFILE: 'Preview my profile',
      MY_AVAILABILITY: 'My availability',
      HIDE_PROFILE: 'Hide profile',
      GENERAL_SETTINGS: 'GENERAL SETTINGS',
      PAYMENT_SETTINGS: 'Payment settings',
      EMAIL_NOTIFICATION: 'Email notification',
      BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
      BANK_ACCOUNT: 'Bank account',
      ID_VERIFICATION: 'ID Verification',
      I_WANT_TO_TAKE_PART: 'I want to take part',
    },
    SIGN_UP: {
      CONFIRM_EMAIL: 'Now confirm your email address',
      RESEND: 'Resend',
      CONFIRM_EMAIL_MESSAGE: (email) => <span>We've sent an email to {email}, please check your inbox and click the link 'Activate' to confirm and earn!</span>,
      USE_ANOTHER_EMAIL: 'Use another email',
      SECTOR: 'Sector',
      CATEGORY: 'Category',
      PLEASE_SELECT_CATEGORY: 'Please select category',
      PROFESSION: 'Profession',
      DESCRIPTION: 'Description',
      FREE: 'Free',
      PER_MINUTE: 'per minute',
      BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
      TERMS_OF_USE: 'Terms of use',
      AND_THE: 'and the',
      PRIVACY_POLICY: 'Privacy Policy',
      THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
      CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
      ACCOUNT_TYPE: 'Account type',
      APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
      CANCEL_CHANGES: 'Cancel changes',
      PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
      ERROR: 'Error',
      PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
      UNITED_KINGDOM: 'United Kingdom',
      ONLY_UK_NOW: 'Only UK for now',
      I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
      ALREADY_HAVE_ACCOUNT: 'Already have an account',
      CODE_HAVE_BEEN_SENT: 'Code has been sent to',
      EDUCATION: {
        EDUCATION: 'Education',
        LANGUAGE_TUTOR: 'Language tutor',
        LANGUAGE_PRACTICE: 'Language practice',
        EXAMS_PREPARATION: 'Exams preparation',
        SCIENCE: 'Science',
        BUSINESS_STUDIES: 'Business studies',
        SOCIAL_SCIENCE: 'Social science',
        DRAWING: 'Drawing',
        MUSIC: 'Music',
        DANCE: 'Dance',
      },
      SERVICES: {
        SERVICES: 'Services',
        INTERPRETER: 'Interpreter',
        NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
        THERAPIST: 'Therapist',
        LISTENER: 'Listener',
        SPEECH_THERAPIST: 'Speech therapist',
        FORTUN_TELLER: 'Fortun teller',
        ASTROLOGIST: 'Astrologist',
        PERSONAL_ASSISTANT: 'Personal assistant',
        CAREER_COACH: 'Career coach',
      },
      CONSULTANCY: {
        CONSULTANCY: 'Consultancy',
        LEGAL: 'Legal',
        MEDICAL: 'Medical',
        BUSINESS: 'Business',
        FAMILY: 'Family',
        INVESTMENT: 'Investment',
        TECH_SUPPORT: 'Tech support',
        BEAUTICIAN: 'Beautician',
      },
      HEALTH_LIFESTYLE: {
        HEALTH_LIFESTYLE: 'Health&Lifestyle',
        PERSONAL_TRAINER: 'Personal trainer',
        YOGA_INSTRUCTOR: 'Yuga instructor',
        MEDITATION_INSTRUCTOR: 'Meditation instructor',
        DIETOLOGIST: 'Dietologist',
        SPORT_COACH: 'Sport coach',
        FITNESS_PROFESSIONAL: 'Fitness professional',
        SPIRITUAL_COACH: 'Spiritual coach',
      },
      PLEASE_SELECT_SECTOR: 'Please select sector',
      PLEASE_ENTER_PROFESSION: 'Please enter profession',
      PLEASE_ENTER_DESCRIPTION: 'Please enter description',
      PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
      PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
      YOU_ARE_UNDER_18: 'You are under 18',
      DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
      YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
      PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
      CITY_IN_THE_UK: 'City in the UK',
      CITY_INCORRECT: 'City incorrect',
      POSTCODE: 'Postcode',
      PLEASE_ENTER_POSTCODE: 'Please enter postcode',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      ONLY_UK_ADDRESS: 'Only UK address',
      ADDRESS_INCORRECT: 'Address incorrect',
      ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
      BIRTHDAY_INCORRECT: 'Birthday incorrect',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      WE_WONT_SHARE_IT: 'We won\'t share it with others.',
      MOBILE_INCORRECT: 'Mobile incorrect',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      EG_IO: 'e.g. i0ONOZLgCIM',
      SERVICE_INCORRECT: 'Service incorrect',
      SERVICE_LABEL: 'Service (20 characters)',
      IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
      SERVICE_NAME_INCORRECT: 'Service name incorrect',
      SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
      SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
      SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
      PRICE_PER_MINUTE: 'Price per minute',
      DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
      YES: 'Yes.',
      NO: 'No.',
      DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
      YES_SAVE: 'Yes, save.',
      DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
      ENTER_TAX_ID: 'Enter tax ID to check',
      CHECK: 'Check.',
      PLEASE_ENTER_PASSWORD: 'Please enter password',
      FIRST_NAME: 'First name',
    },
    SOCIAL_NETWORK: {
      CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
      CONTINUE_WITH_GOOGLE: 'Continue with Google',
    },
    ROUTES: {
      ERROR_404: 'Error 404',
      PAGE_NOT_FOUND: 'Page not found',
      THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
      GO_HOME: 'Go Home',
      FEATURED_SERVICE: 'FEATURED SERVICE',
      WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
      GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
      FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
      CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
      NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
      YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
      RESET: 'Reset',
      BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
      TELMIE_T_C: 'Telmie T&C',
      TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
      AND: 'and',
      STRIPE_T_C: 'Stripe T&C.',
      SORRY: 'Sorry',
      IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
      OR: 'or',
      IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
      BACK_TO_SETTINGS: 'Back to Settings',
      PROFILE_PREVIEW: 'Profile preview',
      PRO_DETAILS: 'Pro details',
      PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
      RESULTS_FOR: 'Results for',
      SORRY_NO_PROS: 'Sorry, no pros found for',
      SELECT_YOUR_INTEREST: 'Select your interest',
      TELMIE_MY_CLIENTS: 'Telmie | My Clients',
      FIND_YOUR_CLIENT: 'Find your Client',
      TELMIE_MY_PROS: 'Telmie | My Pros',
      FIND_YOUR_PRO: 'Find your Pro',
      PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
      TELMIE_PREVIEW: 'Telmie | Preview',
      LOWEST_RATE_FIRST: 'Lowest rate first',
      HIGHEST_RATE_FIRST: 'Highest rate first',
      EXPERIENCE: 'Experience',
      RATING: 'Rating',
      ACTIVITY: 'Activity',
      LANGUAGES: 'Languages',
      COACHING: 'Coaching',
      IMMIGRATION: 'Immigration',
      OTHER: 'Other',
      ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
      ERROR_WITH_STRIPE: 'Error with Stripe.',
      TELMIE_PRO: 'Telmie | Pro',
    },
    FOOTER: {
      HOME: 'Strona domowa',
      CONTACT: 'Kontakt',
      SUPPORT: 'Support',
      POLICY: 'Polityka prywatności',
      TERMS: 'Warunki',
      FAQ: 'FAQ',
      COPYRIGHT: 'Copyright',
      COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom',
    },
    CONTACT_US: {
      title: 'Kontakt',
      subTitle: 'Masz pytania? Napisz do nas',
      name: 'Imię',
      email: 'E-mail',
      company: 'Firma',
      subject: 'Temat',
      message: 'Wpisz swoją wiadomość',
      success: 'Dziękujemy za Twoją wiadomość',
      submitBtn: 'Wyślij',
    },
    SERVICES: {
      LANGUAGE_PRACTICE: 'Ćwiczenie umiejętności językowych',
      IMMIGRATION_ADVICE: 'Porady dotyczące imigracji',
      IMMIGRATION_CONSULTANT: 'Doradca do spraw imigracji',
      LANGUAGE_LEARNERS: 'Nauka języków',
    },
    FAQ: 'FAQ',
    MORE_FAQ: 'Więcej pytania',
    API: {
      NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content',
    },
    NOTIFICATIONS: {
      DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
      EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
      MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
      SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
      UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!',
    },
    REGISTER_PRO: {
      FIRST_NAME: 'First name',
      FIRST_NAME_ERROR: 'First name field is required',
      LAST_NAME: 'Last name',
      LAST_NAME_ERROR: 'Last name field is required',
      COUNTRY: 'Country',
      COUNTRY_PLACEHOLDER: 'Select country',
      COUNTRY_ERROR: 'Country field is required',
      CITY: 'City',
      POSTCODE: 'Postcode',
      POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
      DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
      DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      MOBILE_HINT: 'We won\'t share it with others.',
      MOBILE_ERROR: 'Must contain only numbers',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
      SERVICES: 'Services',
      SERVICES_PLACEHOLDER: 'Select service',
      SERVICES_ERROR: 'Services field is required',
      SERVICE: 'Service (20 characters)',
      SERVICE_HINT: 'i.e. English practice, Immigration advice',
      SERVICE_ERROR: 'Service name may not be greater than 20 characters',
      SECTOR: 'Sector',
      SECTOR_PLACEHOLDER: 'Select sector',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
      SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
      SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
      SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
      SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
      COST_PER_MINUTE_ERROR: 'Please enter price',
      COST_PER_MINUTE_MAX: 'Maximum allowed for this service',
    },
  },
  [AE]: {
    DOWNLOAD_APP_BTN: 'تحميل التطبيق',
    HOMEPAGE_FAQ_TITLE: 'الأسئلة الأكثر شيوعًا',
    GENERAL_QUESTIONS: 'شائع',
    CUSTOMERS_QUESTIONS: 'العملاء',
    EXPERTS_QUESTIONS: 'خبير',
    PAYMENTS_QUESTIONS: 'المدفوعات',
    BLOG_TITLE: 'مدونة',
    FULL_STORY_BTN: 'قصه كامله',
    OTHER_POSTS: 'وظيفة أخرى',
    MISC: {
      DELETE: 'Delete',
      UPDATE_NOW: 'Update now',
      CONNECTING: 'Connecting',
      CONNECTING_TO_SERVER: 'Connecting to server',
      CALLING_PRO: 'Calling Pro',
      CREDIT_CARD: 'Credit card',
      ADD_A_CARD: 'Add a card',
      SUBMIT: 'Submit',
      EMAIL: 'Email',
      SAVE: 'Save',
      OK: 'OK',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
      PLEASE_ENTER_LAST_NAME: 'Please enter last name',
      YOU_WILL_PAY: 'You will pay',
      PER_MINUTE_FOR_CALL: 'per minute for this call',
      MINUTES_SHORT: 'min',
      BECOME_PRO: 'إحترف',
      BLOG: 'مدونة',
      FIND_A_PRO: 'Find a Pro',
      MY_CLIENTS: 'My Clients',
      MY_PROS: 'My Pros',
      MY_APPOINTMENTS: 'My Appointments',
      SIGN_UP: 'Sign Up',
      LOG_OUT: 'Log out',
      REGISTER_AS_PRO: 'Register as Pro',
      REGISTER: 'Register',
      LOG_IN: 'Log in',
      FORGOT_PASSWORD: 'Forgot password',
      PASSWORD: 'Password',
      DATE: 'Date',
      DATE_AND_TIME: 'Date and time',
      DURATION: 'Duration',
      TYPE: 'Type',
      EDIT: 'Edit',
      NAME: 'Name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      MOBILE: 'Mobile',
      CITY: 'City',
      BUSINESS_NAME: 'Business name',
      COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
      COUNTRY: 'Country',
      RATE: 'Rate',
      YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
      CODE_VERIFIED: 'Code verified',
      IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
      CODE_EXPIRES_IN: 'Code expires in',
      CODE: 'Code',
      VERIFY_CODE: 'Verify code',
      PLEASE_ENTER_EMAIL: 'Please enter email',
      RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
      SEND_VERIFICATION_CODE: 'Send verification code',
      LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully',
    },
    BLOG: {
      COMMENTS: 'Comments',
      REPLY: 'Reply',
      ADD_COMMENT: 'Add Comment',
      POST_COMMENT: 'Post comment',
    },
    BOOKING: {
      CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
      CANCELLATION_POLICY: 'Cancellation Policy',
      CANCEL_APPOINTMENT: 'Cancel Appointment',
      PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
      YES_CANCEL: 'Yes, cancel',
      NO_KEEP: 'No, keep it',
    },
    COMMUNICATION: {
      ON_CALL_WITH: 'On call with',
      CONNECTING_WITH: 'Connecting with',
      INCOMING_CALL: 'Incoming Call',
      YOUR_CLIENT: 'Your client',
      TYPE_YOUR_MESSAGE: 'Type your message',
      MIN: 'min',
      CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.',
    },
    CREDIT_CARD: {
      CARD_NUMBER: 'Card number',
      CARD_HOLDER: 'Card holder',
      EXPIRY_DATE: 'Expiry date',
      CVV: 'CVV',
      CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
      SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
      SAVE_PAYMENT_METHOD: 'Save payment method',
      X2_BONUS: 'x2 BONUS',
      YOU_WILL_GET: 'You will get',
      TELMIE_CREDIT: 'Telmie credit',
      IN_TOTAL: 'in total',
      CONFIRM_AND_PAY: 'Confirm & Pay',
      CANNOT_WITHDRAW: 'Cannot withdraw',
      FEE: 'fee',
      FREE: 'Free',
      YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
      AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
      AVALIABLE: 'Available',
      AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
      WITHDRAW: 'Withdraw',
      FREE_APPLIES: 'Fee applies: ',
      YOU_RECEIVE: 'You receive: ',
      WITHDRAWAL_RULES: 'Withdrawal rules',
      WITHDRAWAL_AMOUNT: 'Withdrawal amount',
      HIDE: 'Hide',
      SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules',
    },
    EDIT_PROFILE: {
      SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
      CANT_BE_CHANGED: 'Can\'t be changed',
      UPLOAD_PICTURE: 'Upload picture',
      NAME_ISNT_VALID: 'The name isn\'t valid.',
    },
    FEATURED_SERVICE: {
      CALL_NOW: 'Call now',
      CANCEL_CALL: 'Cancel call',
      NEXT_PRO: 'Next pro',
      NEXT_PRO_CAPS: 'NEXT PRO',
      THEN_CAPS: 'THEN',
    },
    HEADER: {
      HOW_IT_WORKS: 'كيف يعمل',
      FAQ: 'الأسئلة الشائعة',
      CONTACT: 'إتصل بنا',
      MONEY: 'Money',
      SETTINGS: 'Settings',
      LOGIN: 'Log in',
      EDIT_PROFILE: 'Edit Profile',
      NEW_CHATS: 'New Chats',
      WELL_DONE: 'Well done',
      SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
      EDIT_PRO_DETAILS: 'Edit Pro details',
    },
    HOMEPAGE: {
      FEATURED_PROS: 'Featured Pros',
      FEATURED_SERVICES: 'Featured services',
      DOWNLOAD_TELMIE_APP: 'Download Telmie app',
    },
    LANGUAGE_PRACTICE: {
      HAPPY_PROS: 'Happy Pros',
      HAPPY_USERS: 'Happy Users',
    },
    LOG_IN: {
      LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
      NEW_TO_TELMIE: 'New to Telmie',
      DOWNLOAD_THE_APP: 'Download the app',
    },
    NEW_LANDING: {
      MINUTES: 'minutes',
      COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
      BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
      PLEASE_ENTER_SUBJECT: 'Please enter subject',
      PLEASE_ENTER_MESSAGE: 'Please enter message',
    },
    PRO: {
      PRO: 'Pro',
      AMOUNT: 'Amount',
      NO_RECENT_CALLS: 'No recent calls',
      MESSAGES: 'Messages',
      START_CALL: 'Start Call',
      SHORTLISTED: 'Shortlisted',
      REMOVE: 'Remove',
      SHORTLIST: 'Shortlist',
      LOADING: 'Loading',
      TELMIE_CLIENT: 'Telmie Client',
      ON_CALL: 'On call',
      RECONNECTING: 'Reconnecting...',
      TELMIE_USER_IS_CALLING: 'Telmie user is calling',
      SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
      HOURS_FIRST_LETTER: 'h',
      MINUTES_FIRST_LETTER: 'm',
      CALENDAR_TITLE: 'My availability',
      CALENDAR_SUB_TITLE: 'I am not available right now',
      CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
      AVAILABLE_NOW: 'Available now',
      AVAILABLE_LATTER: 'Available later',
      WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
      PRO_IS_BUSY: 'Pro is busy',
    },
    PROFILE: {
      VIEW_ALL: 'View all',
      CONTACT: 'Contact',
      COUNT: 'Count',
      NO_RECENT_ACTIVITY: 'No recent activity',
      YOUR_DETAILS: 'Your details',
      LOCATION: 'Location',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      NO_RECENT_PROS: 'No recent PROS',
      WITHDRAW_EARNINGS: 'Withdraw earnings',
      TOP_UP: 'Top Up',
      ATTACH_CARD: 'Attach card',
      SERVICE: 'Service',
      APPOINTMENT_WITH: 'Appointment with',
      COST: 'Cost',
      BALANCE: 'Balance',
      NO_RECENT_TRANSACTIONS: 'No recent transactions',
      NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
      CLIENT: 'Client',
    },
    RADIO_BUTTONS: {
      APPROVED: 'Approved',
      SECTORS: 'SECTORS',
    },
    SEARCH: {
      FILTERS: 'Filters',
      SESSIONS: 'sessions',
      ARRANGE_BY: 'Arrange by',
      ENTER_KEYWORDS: 'Enter keywords',
      RESET_FILTERS: 'Clear all',
    },
    SELECT: {
      EVERY: 'Every',
    },
    SETTINGS: {
      IMPORTANT_VIA_EMAIL: 'Important via email',
      WORKING_AS_PRO: 'Working as Pro',
      PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
      ADD_NEW_PERIOD: 'Add new period',
      CHANGE_BANK_ACCOUNT: 'Change bank account',
      ADD_BANK_ACCOUNT: 'Add bank account',
      ENTITY: 'Entity',
      ADDRESS: 'Address',
      YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
      WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
      SORT_CODE: 'Sort code',
      DIGITS_VALUE: 'digits value',
      ACCOUNT_NUMBER: 'Account number',
      BAD_REQUEST_DATA: 'Bad Request data',
      PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
      CONFIRM: 'Confirm',
      UPLOAD_ANOTHER_IMAGE: 'Upload another image',
      UPLOAD: 'Upload',
      YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
      YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
      PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
      POST_CODE: 'Post Code',
      LOADING_CARDS: 'Loading cards',
      NO_CARDS: 'No cards.',
      COMPANY_ADDRESS: 'Company address',
      PERSONAL_ADDRESS: 'Personal address',
      SERVICE_NAME: 'Service name',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_SUB_CATEGORY: 'Service sub-category',
      SERVICE_DESCRIPTION: 'Service description',
      PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
      LOADING_ACCOUNTS: 'Loading accounts',
      ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
      PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
      THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
      DAYS_REQUIRED: 'Please select days',
      FROM: 'From',
      TO: 'To',
      COMPANY: 'Company',
      INDIVIDUAL: 'Individual',
      PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
      PROFILE_DETAILS: 'Profile details',
      PRO_SETTINGS: 'PRO SETTINGS',
      WORK_AS_PRO: 'Work as Pro',
      PRO_DETAILS: 'Pro details',
      PAYOUT_BANK_DETAILS: 'Payout bank details',
      PREVIEW_MY_PROFILE: 'Preview my profile',
      MY_AVAILABILITY: 'My availability',
      HIDE_PROFILE: 'Hide profile',
      GENERAL_SETTINGS: 'GENERAL SETTINGS',
      PAYMENT_SETTINGS: 'Payment settings',
      EMAIL_NOTIFICATION: 'Email notification',
      BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
      BANK_ACCOUNT: 'Bank account',
      ID_VERIFICATION: 'ID Verification',
      I_WANT_TO_TAKE_PART: 'I want to take part',
    },
    SIGN_UP: {
      CONFIRM_EMAIL: 'Now confirm your email address',
      RESEND: 'Resend',
      CONFIRM_EMAIL_MESSAGE: (email) => <span>We've sent an email to {email}, please check your inbox and click the link 'Activate' to confirm and earn!</span>,
      USE_ANOTHER_EMAIL: 'Use another email',
      SECTOR: 'Sector',
      CATEGORY: 'Category',
      PLEASE_SELECT_CATEGORY: 'Please select category',
      PROFESSION: 'Profession',
      DESCRIPTION: 'Description',
      FREE: 'Free',
      PER_MINUTE: 'per minute',
      BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
      TERMS_OF_USE: 'Terms of use',
      AND_THE: 'and the',
      PRIVACY_POLICY: 'Privacy Policy',
      THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
      CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
      ACCOUNT_TYPE: 'Account type',
      APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
      CANCEL_CHANGES: 'Cancel changes',
      PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
      ERROR: 'Error',
      PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
      UNITED_KINGDOM: 'United Kingdom',
      ONLY_UK_NOW: 'Only UK for now',
      I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
      ALREADY_HAVE_ACCOUNT: 'Already have an account',
      CODE_HAVE_BEEN_SENT: 'Code has been sent to',
      EDUCATION: {
        EDUCATION: 'Education',
        LANGUAGE_TUTOR: 'Language tutor',
        LANGUAGE_PRACTICE: 'Language practice',
        EXAMS_PREPARATION: 'Exams preparation',
        SCIENCE: 'Science',
        BUSINESS_STUDIES: 'Business studies',
        SOCIAL_SCIENCE: 'Social science',
        DRAWING: 'Drawing',
        MUSIC: 'Music',
        DANCE: 'Dance',
      },
      SERVICES: {
        SERVICES: 'Services',
        INTERPRETER: 'Interpreter',
        NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
        THERAPIST: 'Therapist',
        LISTENER: 'Listener',
        SPEECH_THERAPIST: 'Speech therapist',
        FORTUN_TELLER: 'Fortun teller',
        ASTROLOGIST: 'Astrologist',
        PERSONAL_ASSISTANT: 'Personal assistant',
        CAREER_COACH: 'Career coach',
      },
      CONSULTANCY: {
        CONSULTANCY: 'Consultancy',
        LEGAL: 'Legal',
        MEDICAL: 'Medical',
        BUSINESS: 'Business',
        FAMILY: 'Family',
        INVESTMENT: 'Investment',
        TECH_SUPPORT: 'Tech support',
        BEAUTICIAN: 'Beautician',
      },
      HEALTH_LIFESTYLE: {
        HEALTH_LIFESTYLE: 'Health&Lifestyle',
        PERSONAL_TRAINER: 'Personal trainer',
        YOGA_INSTRUCTOR: 'Yuga instructor',
        MEDITATION_INSTRUCTOR: 'Meditation instructor',
        DIETOLOGIST: 'Dietologist',
        SPORT_COACH: 'Sport coach',
        FITNESS_PROFESSIONAL: 'Fitness professional',
        SPIRITUAL_COACH: 'Spiritual coach',
      },
      PLEASE_SELECT_SECTOR: 'Please select sector',
      PLEASE_ENTER_PROFESSION: 'Please enter profession',
      PLEASE_ENTER_DESCRIPTION: 'Please enter description',
      PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
      PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
      YOU_ARE_UNDER_18: 'You are under 18',
      DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
      YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
      PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
      CITY_IN_THE_UK: 'City in the UK',
      CITY_INCORRECT: 'City incorrect',
      POSTCODE: 'Postcode',
      PLEASE_ENTER_POSTCODE: 'Please enter postcode',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      ONLY_UK_ADDRESS: 'Only UK address',
      ADDRESS_INCORRECT: 'Address incorrect',
      ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
      BIRTHDAY_INCORRECT: 'Birthday incorrect',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      WE_WONT_SHARE_IT: 'We won\'t share it with others.',
      MOBILE_INCORRECT: 'Mobile incorrect',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      EG_IO: 'e.g. i0ONOZLgCIM',
      SERVICE_INCORRECT: 'Service incorrect',
      SERVICE_LABEL: 'Service (20 characters)',
      IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
      SERVICE_NAME_INCORRECT: 'Service name incorrect',
      SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
      SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
      SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
      PRICE_PER_MINUTE: 'Price per minute',
      DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
      YES: 'Yes.',
      NO: 'No.',
      DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
      YES_SAVE: 'Yes, save.',
      DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
      ENTER_TAX_ID: 'Enter tax ID to check',
      CHECK: 'Check.',
      PLEASE_ENTER_PASSWORD: 'Please enter password',
      FIRST_NAME: 'First name',
    },
    SOCIAL_NETWORK: {
      CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
      CONTINUE_WITH_GOOGLE: 'Continue with Google',
    },
    ROUTES: {
      ERROR_404: 'Error 404',
      PAGE_NOT_FOUND: 'Page not found',
      THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
      GO_HOME: 'Go Home',
      FEATURED_SERVICE: 'FEATURED SERVICE',
      WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
      GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
      FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
      CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
      NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
      YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
      RESET: 'Reset',
      BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
      TELMIE_T_C: 'Telmie T&C',
      TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
      AND: 'and',
      STRIPE_T_C: 'Stripe T&C.',
      SORRY: 'Sorry',
      IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
      OR: 'or',
      IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
      BACK_TO_SETTINGS: 'Back to Settings',
      PROFILE_PREVIEW: 'Profile preview',
      PRO_DETAILS: 'Pro details',
      PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
      RESULTS_FOR: 'Results for',
      SORRY_NO_PROS: 'Sorry, no pros found for',
      SELECT_YOUR_INTEREST: 'Select your interest',
      TELMIE_MY_CLIENTS: 'Telmie | My Clients',
      FIND_YOUR_CLIENT: 'Find your Client',
      TELMIE_MY_PROS: 'Telmie | My Pros',
      FIND_YOUR_PRO: 'Find your Pro',
      PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
      TELMIE_PREVIEW: 'Telmie | Preview',
      LOWEST_RATE_FIRST: 'Lowest rate first',
      HIGHEST_RATE_FIRST: 'Highest rate first',
      EXPERIENCE: 'Experience',
      RATING: 'Rating',
      ACTIVITY: 'Activity',
      LANGUAGES: 'Languages',
      COACHING: 'Coaching',
      IMMIGRATION: 'Immigration',
      OTHER: 'Other',
      ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
      ERROR_WITH_STRIPE: 'Error with Stripe.',
      TELMIE_PRO: 'Telmie | Pro',
    },
    FOOTER: {
      HOME: 'الرئيسية',
      CONTACT: 'إتصل بنا',
      SUPPORT: 'Support',
      POLICY: 'سياسة الخصوصية',
      TERMS: 'البنود',
      FAQ: 'الأسئلة الشائعة',
      COPYRIGHT: 'Copyright',
      COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom',
    },
    CONTACT_US: {
      title: 'إتصل بنا',
      subTitle: 'أى أسئلة ؟ إكتب لنا ',
      name: 'إسم',
      email: 'بريد إلكترونى ',
      company: 'شركة',
      subject: 'الموضوع',
      message: 'إكتب رسالتك',
      success: 'نشكرك على إتصالك بنا',
      submitBtn: 'أرسل',
    },
    SERVICES: {
      LANGUAGE_PRACTICE: 'تدريب اللغة',
      IMMIGRATION_ADVICE: 'إستشارات الهجرة',
      IMMIGRATION_CONSULTANT: 'مستشار هجرة',
      LANGUAGE_LEARNERS: 'تعلم اللغة',
    },
    FAQ: 'الأسئلة الشائعة',
    MORE_FAQ: 'المزيد من الأسئلة',
    API: {
      NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content',
    },
    NOTIFICATIONS: {
      DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
      EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
      MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
      SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
      UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!',
    },
    REGISTER_PRO: {
      FIRST_NAME: 'First name',
      FIRST_NAME_ERROR: 'First name field is required',
      LAST_NAME: 'Last name',
      LAST_NAME_ERROR: 'Last name field is required',
      COUNTRY: 'Country',
      COUNTRY_PLACEHOLDER: 'Select country',
      COUNTRY_ERROR: 'Country field is required',
      CITY: 'City',
      POSTCODE: 'Postcode',
      POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
      DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
      DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      MOBILE_HINT: 'We won\'t share it with others.',
      MOBILE_ERROR: 'Must contain only numbers',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
      SERVICES: 'Services',
      SERVICES_PLACEHOLDER: 'Select service',
      SERVICES_ERROR: 'Services field is required',
      SERVICE: 'Service (20 characters)',
      SERVICE_HINT: 'i.e. English practice, Immigration advice',
      SERVICE_ERROR: 'Service name may not be greater than 20 characters',
      SECTOR: 'Sector',
      SECTOR_PLACEHOLDER: 'Select sector',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
      SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
      SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
      SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
      SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
      COST_PER_MINUTE_ERROR: 'Please enter price',
      COST_PER_MINUTE_MAX: 'Maximum allowed for this service',
    },
  },
  [PT]: {
    DOWNLOAD_APP_BTN: 'Baixar o App',
    HOMEPAGE_FAQ_TITLE: 'Perguntas mais populares',
    GENERAL_QUESTIONS: 'Questões Gerais',
    CUSTOMERS_QUESTIONS: 'Clientes',
    EXPERTS_QUESTIONS: 'Especialista',
    PAYMENTS_QUESTIONS: 'Pagamentos',
    BLOG_TITLE: 'Blog',
    FULL_STORY_BTN: 'História completa',
    OTHER_POSTS: 'Outros posts',
    MISC: {
      DELETE: 'Delete',
      UPDATE_NOW: 'Update now',
      CONNECTING: 'Connecting',
      CONNECTING_TO_SERVER: 'Connecting to server',
      CALLING_PRO: 'Calling Pro',
      CREDIT_CARD: 'Credit card',
      ADD_A_CARD: 'Add a card',
      SUBMIT: 'Submit',
      EMAIL: 'Email',
      SAVE: 'Save',
      OK: 'OK',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
      PLEASE_ENTER_LAST_NAME: 'Please enter last name',
      YOU_WILL_PAY: 'You will pay',
      PER_MINUTE_FOR_CALL: 'per minute for this call',
      MINUTES_SHORT: 'min',
      BECOME_PRO: 'Torne-se um pro',
      BLOG: 'Blog',
      FIND_A_PRO: 'Find a Pro',
      MY_CLIENTS: 'My Clients',
      MY_PROS: 'My Pros',
      MY_APPOINTMENTS: 'My Appointments',
      SIGN_UP: 'Sign Up',
      LOG_OUT: 'Log out',
      REGISTER_AS_PRO: 'Register as Pro',
      REGISTER: 'Register',
      LOG_IN: 'Log in',
      FORGOT_PASSWORD: 'Forgot password',
      PASSWORD: 'Password',
      DATE: 'Date',
      DATE_AND_TIME: 'Date and time',
      DURATION: 'Duration',
      TYPE: 'Type',
      EDIT: 'Edit',
      NAME: 'Name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      MOBILE: 'Mobile',
      CITY: 'City',
      BUSINESS_NAME: 'Business name',
      COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
      COUNTRY: 'Country',
      RATE: 'Rate',
      YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
      CODE_VERIFIED: 'Code verified',
      IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
      CODE_EXPIRES_IN: 'Code expires in',
      CODE: 'Code',
      VERIFY_CODE: 'Verify code',
      PLEASE_ENTER_EMAIL: 'Please enter email',
      RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
      SEND_VERIFICATION_CODE: 'Send verification code',
      LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully',
    },
    BLOG: {
      COMMENTS: 'Comments',
      REPLY: 'Reply',
      ADD_COMMENT: 'Add Comment',
      POST_COMMENT: 'Post comment',
    },
    BOOKING: {
      CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
      CANCELLATION_POLICY: 'Cancellation Policy',
      CANCEL_APPOINTMENT: 'Cancel Appointment',
      PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
      YES_CANCEL: 'Yes, cancel',
      NO_KEEP: 'No, keep it',
    },
    COMMUNICATION: {
      ON_CALL_WITH: 'On call with',
      CONNECTING_WITH: 'Connecting with',
      INCOMING_CALL: 'Incoming Call',
      YOUR_CLIENT: 'Your client',
      TYPE_YOUR_MESSAGE: 'Type your message',
      MIN: 'min',
      CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.',
    },
    CREDIT_CARD: {
      CARD_NUMBER: 'Card number',
      CARD_HOLDER: 'Card holder',
      EXPIRY_DATE: 'Expiry date',
      CVV: 'CVV',
      CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
      SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
      SAVE_PAYMENT_METHOD: 'Save payment method',
      X2_BONUS: 'x2 BONUS',
      YOU_WILL_GET: 'You will get',
      TELMIE_CREDIT: 'Telmie credit',
      IN_TOTAL: 'in total',
      CONFIRM_AND_PAY: 'Confirm & Pay',
      CANNOT_WITHDRAW: 'Cannot withdraw',
      FEE: 'fee',
      FREE: 'Free',
      YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
      AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
      AVALIABLE: 'Available',
      AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
      WITHDRAW: 'Withdraw',
      FREE_APPLIES: 'Fee applies: ',
      YOU_RECEIVE: 'You receive: ',
      WITHDRAWAL_RULES: 'Withdrawal rules',
      WITHDRAWAL_AMOUNT: 'Withdrawal amount',
      HIDE: 'Hide',
      SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules',
    },
    EDIT_PROFILE: {
      SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
      CANT_BE_CHANGED: 'Can\'t be changed',
      UPLOAD_PICTURE: 'Upload picture',
      NAME_ISNT_VALID: 'The name isn\'t valid.',
    },
    FEATURED_SERVICE: {
      CALL_NOW: 'Call now',
      CANCEL_CALL: 'Cancel call',
      NEXT_PRO: 'Next pro',
      NEXT_PRO_CAPS: 'NEXT PRO',
      THEN_CAPS: 'THEN',
    },
    HEADER: {
      HOW_IT_WORKS: 'Como funciona',
      FAQ: 'Perguntas frequentes',
      CONTACT: 'Fale conosco',
      MONEY: 'Money',
      SETTINGS: 'Settings',
      LOGIN: 'Log in',
      EDIT_PROFILE: 'Edit Profile',
      NEW_CHATS: 'New Chats',
      WELL_DONE: 'Well done',
      SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
      EDIT_PRO_DETAILS: 'Edit Pro details',
    },
    HOMEPAGE: {
      FEATURED_PROS: 'Featured Pros',
      FEATURED_SERVICES: 'Featured services',
      DOWNLOAD_TELMIE_APP: 'Download Telmie app',
    },
    LANGUAGE_PRACTICE: {
      HAPPY_PROS: 'Happy Pros',
      HAPPY_USERS: 'Happy Users',
    },
    LOG_IN: {
      LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
      NEW_TO_TELMIE: 'New to Telmie',
      DOWNLOAD_THE_APP: 'Download the app',
    },
    NEW_LANDING: {
      MINUTES: 'minutes',
      COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
      BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
      PLEASE_ENTER_SUBJECT: 'Please enter subject',
      PLEASE_ENTER_MESSAGE: 'Please enter message',
    },
    PRO: {
      PRO: 'Pro',
      AMOUNT: 'Amount',
      NO_RECENT_CALLS: 'No recent calls',
      MESSAGES: 'Messages',
      START_CALL: 'Start Call',
      SHORTLISTED: 'Shortlisted',
      REMOVE: 'Remove',
      SHORTLIST: 'Shortlist',
      LOADING: 'Loading',
      TELMIE_CLIENT: 'Telmie Client',
      ON_CALL: 'On call',
      RECONNECTING: 'Reconnecting...',
      TELMIE_USER_IS_CALLING: 'Telmie user is calling',
      SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
      HOURS_FIRST_LETTER: 'h',
      MINUTES_FIRST_LETTER: 'm',
      CALENDAR_TITLE: 'My availability',
      CALENDAR_SUB_TITLE: 'I am not available right now',
      CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
      AVAILABLE_NOW: 'Available now',
      AVAILABLE_LATTER: 'Available later',
      WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
      PRO_IS_BUSY: 'Pro is busy',
    },
    PROFILE: {
      VIEW_ALL: 'View all',
      CONTACT: 'Contact',
      COUNT: 'Count',
      NO_RECENT_ACTIVITY: 'No recent activity',
      YOUR_DETAILS: 'Your details',
      LOCATION: 'Location',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      NO_RECENT_PROS: 'No recent PROS',
      WITHDRAW_EARNINGS: 'Withdraw earnings',
      TOP_UP: 'Top Up',
      ATTACH_CARD: 'Attach card',
      SERVICE: 'Service',
      APPOINTMENT_WITH: 'Appointment with',
      COST: 'Cost',
      BALANCE: 'Balance',
      NO_RECENT_TRANSACTIONS: 'No recent transactions',
      NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
      CLIENT: 'Client',
    },
    RADIO_BUTTONS: {
      APPROVED: 'Approved',
      SECTORS: 'SECTORS',
    },
    SEARCH: {
      FILTERS: 'Filters',
      SESSIONS: 'sessions',
      ARRANGE_BY: 'Arrange by',
      ENTER_KEYWORDS: 'Enter keywords',
      RESET_FILTERS: 'Clear all',
    },
    SELECT: {
      EVERY: 'Every',
    },
    SETTINGS: {
      IMPORTANT_VIA_EMAIL: 'Important via email',
      WORKING_AS_PRO: 'Working as Pro',
      PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
      ADD_NEW_PERIOD: 'Add new period',
      CHANGE_BANK_ACCOUNT: 'Change bank account',
      ADD_BANK_ACCOUNT: 'Add bank account',
      ENTITY: 'Entity',
      ADDRESS: 'Address',
      YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
      WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
      SORT_CODE: 'Sort code',
      DIGITS_VALUE: 'digits value',
      ACCOUNT_NUMBER: 'Account number',
      BAD_REQUEST_DATA: 'Bad Request data',
      PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
      CONFIRM: 'Confirm',
      UPLOAD_ANOTHER_IMAGE: 'Upload another image',
      UPLOAD: 'Upload',
      YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
      YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
      PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
      POST_CODE: 'Post Code',
      LOADING_CARDS: 'Loading cards',
      NO_CARDS: 'No cards.',
      COMPANY_ADDRESS: 'Company address',
      PERSONAL_ADDRESS: 'Personal address',
      SERVICE_NAME: 'Service name',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_SUB_CATEGORY: 'Service sub-category',
      SERVICE_DESCRIPTION: 'Service description',
      PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
      LOADING_ACCOUNTS: 'Loading accounts',
      ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
      PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
      THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
      DAYS_REQUIRED: 'Please select days',
      FROM: 'From',
      TO: 'To',
      COMPANY: 'Company',
      INDIVIDUAL: 'Individual',
      PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
      PROFILE_DETAILS: 'Profile details',
      PRO_SETTINGS: 'PRO SETTINGS',
      WORK_AS_PRO: 'Work as Pro',
      PRO_DETAILS: 'Pro details',
      PAYOUT_BANK_DETAILS: 'Payout bank details',
      PREVIEW_MY_PROFILE: 'Preview my profile',
      MY_AVAILABILITY: 'My availability',
      HIDE_PROFILE: 'Hide profile',
      GENERAL_SETTINGS: 'GENERAL SETTINGS',
      PAYMENT_SETTINGS: 'Payment settings',
      EMAIL_NOTIFICATION: 'Email notification',
      BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
      BANK_ACCOUNT: 'Bank account',
      ID_VERIFICATION: 'ID Verification',
      I_WANT_TO_TAKE_PART: 'I want to take part',
    },
    SIGN_UP: {
      CONFIRM_EMAIL: 'Now confirm your email address',
      RESEND: 'Resend',
      CONFIRM_EMAIL_MESSAGE: (email) => <span>We've sent an email to {email}, please check your inbox and click the link 'Activate' to confirm and earn!</span>,
      USE_ANOTHER_EMAIL: 'Use another email',
      SECTOR: 'Sector',
      CATEGORY: 'Category',
      PLEASE_SELECT_CATEGORY: 'Please select category',
      PROFESSION: 'Profession',
      DESCRIPTION: 'Description',
      FREE: 'Free',
      PER_MINUTE: 'per minute',
      BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
      TERMS_OF_USE: 'Terms of use',
      AND_THE: 'and the',
      PRIVACY_POLICY: 'Privacy Policy',
      THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
      CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
      ACCOUNT_TYPE: 'Account type',
      APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
      CANCEL_CHANGES: 'Cancel changes',
      PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
      ERROR: 'Error',
      PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
      UNITED_KINGDOM: 'United Kingdom',
      ONLY_UK_NOW: 'Only UK for now',
      I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
      ALREADY_HAVE_ACCOUNT: 'Already have an account',
      CODE_HAVE_BEEN_SENT: 'Code has been sent to',
      EDUCATION: {
        EDUCATION: 'Education',
        LANGUAGE_TUTOR: 'Language tutor',
        LANGUAGE_PRACTICE: 'Language practice',
        EXAMS_PREPARATION: 'Exams preparation',
        SCIENCE: 'Science',
        BUSINESS_STUDIES: 'Business studies',
        SOCIAL_SCIENCE: 'Social science',
        DRAWING: 'Drawing',
        MUSIC: 'Music',
        DANCE: 'Dance',
      },
      SERVICES: {
        SERVICES: 'Services',
        INTERPRETER: 'Interpreter',
        NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
        THERAPIST: 'Therapist',
        LISTENER: 'Listener',
        SPEECH_THERAPIST: 'Speech therapist',
        FORTUN_TELLER: 'Fortun teller',
        ASTROLOGIST: 'Astrologist',
        PERSONAL_ASSISTANT: 'Personal assistant',
        CAREER_COACH: 'Career coach',
      },
      CONSULTANCY: {
        CONSULTANCY: 'Consultancy',
        LEGAL: 'Legal',
        MEDICAL: 'Medical',
        BUSINESS: 'Business',
        FAMILY: 'Family',
        INVESTMENT: 'Investment',
        TECH_SUPPORT: 'Tech support',
        BEAUTICIAN: 'Beautician',
      },
      HEALTH_LIFESTYLE: {
        HEALTH_LIFESTYLE: 'Health&Lifestyle',
        PERSONAL_TRAINER: 'Personal trainer',
        YOGA_INSTRUCTOR: 'Yuga instructor',
        MEDITATION_INSTRUCTOR: 'Meditation instructor',
        DIETOLOGIST: 'Dietologist',
        SPORT_COACH: 'Sport coach',
        FITNESS_PROFESSIONAL: 'Fitness professional',
        SPIRITUAL_COACH: 'Spiritual coach',
      },
      PLEASE_SELECT_SECTOR: 'Please select sector',
      PLEASE_ENTER_PROFESSION: 'Please enter profession',
      PLEASE_ENTER_DESCRIPTION: 'Please enter description',
      PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
      PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
      YOU_ARE_UNDER_18: 'You are under 18',
      DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
      YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
      PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
      CITY_IN_THE_UK: 'City in the UK',
      CITY_INCORRECT: 'City incorrect',
      POSTCODE: 'Postcode',
      PLEASE_ENTER_POSTCODE: 'Please enter postcode',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      ONLY_UK_ADDRESS: 'Only UK address',
      ADDRESS_INCORRECT: 'Address incorrect',
      ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
      BIRTHDAY_INCORRECT: 'Birthday incorrect',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      WE_WONT_SHARE_IT: 'We won\'t share it with others.',
      MOBILE_INCORRECT: 'Mobile incorrect',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      EG_IO: 'e.g. i0ONOZLgCIM',
      SERVICE_INCORRECT: 'Service incorrect',
      SERVICE_LABEL: 'Service (20 characters)',
      IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
      SERVICE_NAME_INCORRECT: 'Service name incorrect',
      SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
      SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
      SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
      PRICE_PER_MINUTE: 'Price per minute',
      DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
      YES: 'Yes.',
      NO: 'No.',
      DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
      YES_SAVE: 'Yes, save.',
      DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
      ENTER_TAX_ID: 'Enter tax ID to check',
      CHECK: 'Check.',
      PLEASE_ENTER_PASSWORD: 'Please enter password',
      FIRST_NAME: 'First name',
    },
    SOCIAL_NETWORK: {
      CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
      CONTINUE_WITH_GOOGLE: 'Continue with Google',
    },
    ROUTES: {
      ERROR_404: 'Error 404',
      PAGE_NOT_FOUND: 'Page not found',
      THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
      GO_HOME: 'Go Home',
      FEATURED_SERVICE: 'FEATURED SERVICE',
      WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
      GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
      FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
      CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
      NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
      YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
      RESET: 'Reset',
      BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
      TELMIE_T_C: 'Telmie T&C',
      TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
      AND: 'and',
      STRIPE_T_C: 'Stripe T&C.',
      SORRY: 'Sorry',
      IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
      OR: 'or',
      IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
      BACK_TO_SETTINGS: 'Back to Settings',
      PROFILE_PREVIEW: 'Profile preview',
      PRO_DETAILS: 'Pro details',
      PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
      RESULTS_FOR: 'Results for',
      SORRY_NO_PROS: 'Sorry, no pros found for',
      SELECT_YOUR_INTEREST: 'Select your interest',
      TELMIE_MY_CLIENTS: 'Telmie | My Clients',
      FIND_YOUR_CLIENT: 'Find your Client',
      TELMIE_MY_PROS: 'Telmie | My Pros',
      FIND_YOUR_PRO: 'Find your Pro',
      PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
      TELMIE_PREVIEW: 'Telmie | Preview',
      LOWEST_RATE_FIRST: 'Lowest rate first',
      HIGHEST_RATE_FIRST: 'Highest rate first',
      EXPERIENCE: 'Experience',
      RATING: 'Rating',
      ACTIVITY: 'Activity',
      LANGUAGES: 'Languages',
      COACHING: 'Coaching',
      IMMIGRATION: 'Immigration',
      OTHER: 'Other',
      ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
      ERROR_WITH_STRIPE: 'Error with Stripe.',
      TELMIE_PRO: 'Telmie | Pro',
    },
    FOOTER: {
      HOME: 'Página inicial',
      CONTACT: 'Fale conosco',
      SUPPORT: 'Support',
      POLICY: 'Política de Privacidade',
      TERMS: 'Termos',
      FAQ: 'FAQ',
      COPYRIGHT: 'Copyright',
      COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom',
    },
    CONTACT_US: {
      title: 'Fale conosco',
      subTitle: 'Alguma pergunta? Manda uma mensagem.',
      name: 'Nome',
      email: 'Email',
      company: 'Empresa',
      subject: 'Assunto',
      message: 'Digite sua mensagem',
      success: 'Obrigado por nos contatar',
      submitBtn: 'Enviar',
    },
    SERVICES: {
      LANGUAGE_PRACTICE: 'Prática de idiomas',
      IMMIGRATION_CONSULTANT: 'Assessor de imigração',
      IMMIGRATION_ADVICE: 'Aconselhamento sobre imigração',
      LANGUAGE_LEARNERS: 'Aprendizado de idiomas',
    },
    FAQ: 'Perguntas frequentes',
    MORE_FAQ: 'Mais Perguntas Frequentes',
    API: {
      NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content',
    },
    NOTIFICATIONS: {
      DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
      EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
      MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
      SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
      UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!',
    },
    REGISTER_PRO: {
      FIRST_NAME: 'First name',
      FIRST_NAME_ERROR: 'First name field is required',
      LAST_NAME: 'Last name',
      LAST_NAME_ERROR: 'Last name field is required',
      COUNTRY: 'Country',
      COUNTRY_PLACEHOLDER: 'Select country',
      COUNTRY_ERROR: 'Country field is required',
      CITY: 'City',
      POSTCODE: 'Postcode',
      POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
      DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
      DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      MOBILE_HINT: 'We won\'t share it with others.',
      MOBILE_ERROR: 'Must contain only numbers',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
      SERVICES: 'Services',
      SERVICES_PLACEHOLDER: 'Select service',
      SERVICES_ERROR: 'Services field is required',
      SERVICE: 'Service (20 characters)',
      SERVICE_HINT: 'i.e. English practice, Immigration advice',
      SERVICE_ERROR: 'Service name may not be greater than 20 characters',
      SECTOR: 'Sector',
      SECTOR_PLACEHOLDER: 'Select sector',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
      SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
      SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
      SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
      SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
      COST_PER_MINUTE_ERROR: 'Please enter price',
      COST_PER_MINUTE_MAX: 'Maximum allowed for this service',
    },
  },
  [DE]: {
    DOWNLOAD_APP_BTN: 'App herunterladen',
    HOMEPAGE_FAQ_TITLE: 'Häufig gestellte Fragen',
    GENERAL_QUESTIONS: 'Allgemeine Fragen',
    CUSTOMERS_QUESTIONS: 'Kunden',
    EXPERTS_QUESTIONS: 'Experten',
    PAYMENTS_QUESTIONS: 'Zahlungen',
    BLOG_TITLE: 'Blog',
    FULL_STORY_BTN: 'Unsere Geschichte',
    OTHER_POSTS: 'Mehr Beiträge',
    MISC: {
      DELETE: 'Delete',
      UPDATE_NOW: 'Update now',
      CONNECTING: 'Connecting',
      CONNECTING_TO_SERVER: 'Connecting to server',
      CALLING_PRO: 'Calling Pro',
      CREDIT_CARD: 'Credit card',
      ADD_A_CARD: 'Add a card',
      SUBMIT: 'Submit',
      EMAIL: 'Email',
      SAVE: 'Save',
      OK: 'OK',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
      PLEASE_ENTER_LAST_NAME: 'Please enter last name',
      YOU_WILL_PAY: 'You will pay',
      PER_MINUTE_FOR_CALL: 'per minute for this call',
      MINUTES_SHORT: 'min',
      BECOME_PRO: 'Werde ein profi',
      BLOG: 'Blog',
      FIND_A_PRO: 'Find a Pro',
      MY_CLIENTS: 'My Clients',
      MY_PROS: 'My Pros',
      MY_APPOINTMENTS: 'My Appointments',
      SIGN_UP: 'Sign Up',
      LOG_OUT: 'Log out',
      REGISTER_AS_PRO: 'Register as Pro',
      REGISTER: 'Register',
      LOG_IN: 'Log in',
      FORGOT_PASSWORD: 'Forgot password',
      PASSWORD: 'Password',
      DATE: 'Date',
      DATE_AND_TIME: 'Date and time',
      DURATION: 'Duration',
      TYPE: 'Type',
      EDIT: 'Edit',
      NAME: 'Name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      MOBILE: 'Mobile',
      CITY: 'City',
      BUSINESS_NAME: 'Business name',
      COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
      COUNTRY: 'Country',
      RATE: 'Rate',
      YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
      CODE_VERIFIED: 'Code verified',
      IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
      CODE_EXPIRES_IN: 'Code expires in',
      CODE: 'Code',
      VERIFY_CODE: 'Verify code',
      PLEASE_ENTER_EMAIL: 'Please enter email',
      RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
      SEND_VERIFICATION_CODE: 'Send verification code',
      LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully',
    },
    BLOG: {
      COMMENTS: 'Comments',
      REPLY: 'Reply',
      ADD_COMMENT: 'Add Comment',
      POST_COMMENT: 'Post comment',
    },
    BOOKING: {
      CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
      CANCELLATION_POLICY: 'Cancellation Policy',
      CANCEL_APPOINTMENT: 'Cancel Appointment',
      PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
      YES_CANCEL: 'Yes, cancel',
      NO_KEEP: 'No, keep it',
    },
    COMMUNICATION: {
      ON_CALL_WITH: 'On call with',
      CONNECTING_WITH: 'Connecting with',
      INCOMING_CALL: 'Incoming Call',
      YOUR_CLIENT: 'Your client',
      TYPE_YOUR_MESSAGE: 'Type your message',
      MIN: 'min',
      CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.',
    },
    CREDIT_CARD: {
      CARD_NUMBER: 'Card number',
      CARD_HOLDER: 'Card holder',
      EXPIRY_DATE: 'Expiry date',
      CVV: 'CVV',
      CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
      SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
      SAVE_PAYMENT_METHOD: 'Save payment method',
      X2_BONUS: 'x2 BONUS',
      YOU_WILL_GET: 'You will get',
      TELMIE_CREDIT: 'Telmie credit',
      IN_TOTAL: 'in total',
      CONFIRM_AND_PAY: 'Confirm & Pay',
      CANNOT_WITHDRAW: 'Cannot withdraw',
      FEE: 'fee',
      FREE: 'Free',
      YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
      AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
      AVALIABLE: 'Available',
      AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
      WITHDRAW: 'Withdraw',
      FREE_APPLIES: 'Fee applies: ',
      YOU_RECEIVE: 'You receive: ',
      WITHDRAWAL_RULES: 'Withdrawal rules',
      WITHDRAWAL_AMOUNT: 'Withdrawal amount',
      HIDE: 'Hide',
      SHOW_WITHDRAWAL_RULES: 'Show withdrawal rules',
    },
    EDIT_PROFILE: {
      SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
      CANT_BE_CHANGED: 'Can\'t be changed',
      UPLOAD_PICTURE: 'Upload picture',
      NAME_ISNT_VALID: 'The name isn\'t valid.',
    },
    FEATURED_SERVICE: {
      CALL_NOW: 'Call now',
      CANCEL_CALL: 'Cancel call',
      NEXT_PRO: 'Next pro',
      NEXT_PRO_CAPS: 'NEXT PRO',
      THEN_CAPS: 'THEN',
    },
    HEADER: {
      HOW_IT_WORKS: 'So funktioniert es',
      FAQ: 'FAQ',
      CONTACT: 'Kontaktieren sie uns',
      MONEY: 'Money',
      SETTINGS: 'Settings',
      LOGIN: 'Log in',
      EDIT_PROFILE: 'Edit Profile',
      NEW_CHATS: 'New Chats',
      WELL_DONE: 'Well done',
      SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
      EDIT_PRO_DETAILS: 'Edit Pro details',
    },
    HOMEPAGE: {
      FEATURED_PROS: 'Featured Pros',
      FEATURED_SERVICES: 'Featured services',
      DOWNLOAD_TELMIE_APP: 'Download Telmie app',
    },
    LANGUAGE_PRACTICE: {
      HAPPY_PROS: 'Happy Pros',
      HAPPY_USERS: 'Happy Users',
    },
    LOG_IN: {
      LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
      NEW_TO_TELMIE: 'New to Telmie',
      DOWNLOAD_THE_APP: 'Download the app',
    },
    NEW_LANDING: {
      MINUTES: 'minutes',
      COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
      BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
      PLEASE_ENTER_SUBJECT: 'Please enter subject',
      PLEASE_ENTER_MESSAGE: 'Please enter message',
    },
    PRO: {
      PRO: 'Pro',
      AMOUNT: 'Amount',
      NO_RECENT_CALLS: 'No recent calls',
      MESSAGES: 'Messages',
      START_CALL: 'Start Call',
      SHORTLISTED: 'Shortlisted',
      REMOVE: 'Remove',
      SHORTLIST: 'Shortlist',
      LOADING: 'Loading',
      TELMIE_CLIENT: 'Telmie Client',
      ON_CALL: 'On call',
      RECONNECTING: 'Reconnecting...',
      TELMIE_USER_IS_CALLING: 'Telmie user is calling',
      SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
      HOURS_FIRST_LETTER: 'h',
      MINUTES_FIRST_LETTER: 'm',
      CALENDAR_TITLE: 'My availability',
      CALENDAR_SUB_TITLE: 'I am not available right now',
      CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
      AVAILABLE_NOW: 'Available now',
      AVAILABLE_LATTER: 'Available later',
      WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
      PRO_IS_BUSY: 'Pro is busy',
    },
    PROFILE: {
      VIEW_ALL: 'View all',
      CONTACT: 'Contact',
      COUNT: 'Count',
      NO_RECENT_ACTIVITY: 'No recent activity',
      YOUR_DETAILS: 'Your details',
      LOCATION: 'Location',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      NO_RECENT_PROS: 'No recent PROS',
      WITHDRAW_EARNINGS: 'Withdraw earnings',
      TOP_UP: 'Top Up',
      ATTACH_CARD: 'Attach card',
      SERVICE: 'Service',
      APPOINTMENT_WITH: 'Appointment with',
      COST: 'Cost',
      BALANCE: 'Balance',
      NO_RECENT_TRANSACTIONS: 'No recent transactions',
      NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
      CLIENT: 'Client',
    },
    RADIO_BUTTONS: {
      APPROVED: 'Approved',
      SECTORS: 'SECTORS',
    },
    SEARCH: {
      FILTERS: 'Filters',
      SESSIONS: 'sessions',
      ARRANGE_BY: 'Arrange by',
      ENTER_KEYWORDS: 'Enter keywords',
      RESET_FILTERS: 'Clear all',
    },
    SELECT: {
      EVERY: 'Every',
    },
    SETTINGS: {
      IMPORTANT_VIA_EMAIL: 'Important via email',
      WORKING_AS_PRO: 'Working as Pro',
      PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
      ADD_NEW_PERIOD: 'Add new period',
      CHANGE_BANK_ACCOUNT: 'Change bank account',
      ADD_BANK_ACCOUNT: 'Add bank account',
      ENTITY: 'Entity',
      ADDRESS: 'Address',
      YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
      WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
      SORT_CODE: 'Sort code',
      DIGITS_VALUE: 'digits value',
      ACCOUNT_NUMBER: 'Account number',
      BAD_REQUEST_DATA: 'Bad Request data',
      PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
      CONFIRM: 'Confirm',
      UPLOAD_ANOTHER_IMAGE: 'Upload another image',
      UPLOAD: 'Upload',
      YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
      YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
      PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
      POST_CODE: 'Post Code',
      LOADING_CARDS: 'Loading cards',
      NO_CARDS: 'No cards.',
      COMPANY_ADDRESS: 'Company address',
      PERSONAL_ADDRESS: 'Personal address',
      SERVICE_NAME: 'Service name',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_SUB_CATEGORY: 'Service sub-category',
      SERVICE_DESCRIPTION: 'Service description',
      PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
      LOADING_ACCOUNTS: 'Loading accounts',
      ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
      PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
      THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
      DAYS_REQUIRED: 'Please select days',
      FROM: 'From',
      TO: 'To',
      COMPANY: 'Company',
      INDIVIDUAL: 'Individual',
      PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
      PROFILE_DETAILS: 'Profile details',
      PRO_SETTINGS: 'PRO SETTINGS',
      WORK_AS_PRO: 'Work as Pro',
      PRO_DETAILS: 'Pro details',
      PAYOUT_BANK_DETAILS: 'Payout bank details',
      PREVIEW_MY_PROFILE: 'Preview my profile',
      MY_AVAILABILITY: 'My availability',
      HIDE_PROFILE: 'Hide profile',
      GENERAL_SETTINGS: 'GENERAL SETTINGS',
      PAYMENT_SETTINGS: 'Payment settings',
      EMAIL_NOTIFICATION: 'Email notification',
      BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
      BANK_ACCOUNT: 'Bank account',
      ID_VERIFICATION: 'ID Verification',
      I_WANT_TO_TAKE_PART: 'I want to take part',
    },
    SIGN_UP: {
      CONFIRM_EMAIL: 'Now confirm your email address',
      RESEND: 'Resend',
      CONFIRM_EMAIL_MESSAGE: (email) => <span>We've sent an email to {email}, please check your inbox and click the link 'Activate' to confirm and earn!</span>,
      USE_ANOTHER_EMAIL: 'Use another email',
      SECTOR: 'Sector',
      CATEGORY: 'Category',
      PLEASE_SELECT_CATEGORY: 'Please select category',
      PROFESSION: 'Profession',
      DESCRIPTION: 'Description',
      FREE: 'Free',
      PER_MINUTE: 'per minute',
      BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
      TERMS_OF_USE: 'Terms of use',
      AND_THE: 'and the',
      PRIVACY_POLICY: 'Privacy Policy',
      THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
      CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
      ACCOUNT_TYPE: 'Account type',
      APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
      CANCEL_CHANGES: 'Cancel changes',
      PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
      ERROR: 'Error',
      PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
      UNITED_KINGDOM: 'United Kingdom',
      ONLY_UK_NOW: 'Only UK for now',
      I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
      ALREADY_HAVE_ACCOUNT: 'Already have an account',
      CODE_HAVE_BEEN_SENT: 'Code has been sent to',
      EDUCATION: {
        EDUCATION: 'Education',
        LANGUAGE_TUTOR: 'Language tutor',
        LANGUAGE_PRACTICE: 'Language practice',
        EXAMS_PREPARATION: 'Exams preparation',
        SCIENCE: 'Science',
        BUSINESS_STUDIES: 'Business studies',
        SOCIAL_SCIENCE: 'Social science',
        DRAWING: 'Drawing',
        MUSIC: 'Music',
        DANCE: 'Dance',
      },
      SERVICES: {
        SERVICES: 'Services',
        INTERPRETER: 'Interpreter',
        NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
        THERAPIST: 'Therapist',
        LISTENER: 'Listener',
        SPEECH_THERAPIST: 'Speech therapist',
        FORTUN_TELLER: 'Fortun teller',
        ASTROLOGIST: 'Astrologist',
        PERSONAL_ASSISTANT: 'Personal assistant',
        CAREER_COACH: 'Career coach',
      },
      CONSULTANCY: {
        CONSULTANCY: 'Consultancy',
        LEGAL: 'Legal',
        MEDICAL: 'Medical',
        BUSINESS: 'Business',
        FAMILY: 'Family',
        INVESTMENT: 'Investment',
        TECH_SUPPORT: 'Tech support',
        BEAUTICIAN: 'Beautician',
      },
      HEALTH_LIFESTYLE: {
        HEALTH_LIFESTYLE: 'Health&Lifestyle',
        PERSONAL_TRAINER: 'Personal trainer',
        YOGA_INSTRUCTOR: 'Yuga instructor',
        MEDITATION_INSTRUCTOR: 'Meditation instructor',
        DIETOLOGIST: 'Dietologist',
        SPORT_COACH: 'Sport coach',
        FITNESS_PROFESSIONAL: 'Fitness professional',
        SPIRITUAL_COACH: 'Spiritual coach',
      },
      PLEASE_SELECT_SECTOR: 'Please select sector',
      PLEASE_ENTER_PROFESSION: 'Please enter profession',
      PLEASE_ENTER_DESCRIPTION: 'Please enter description',
      PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
      PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
      YOU_ARE_UNDER_18: 'You are under 18',
      DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
      YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
      PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
      CITY_IN_THE_UK: 'City in the UK',
      CITY_INCORRECT: 'City incorrect',
      POSTCODE: 'Postcode',
      PLEASE_ENTER_POSTCODE: 'Please enter postcode',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      ONLY_UK_ADDRESS: 'Only UK address',
      ADDRESS_INCORRECT: 'Address incorrect',
      ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
      BIRTHDAY_INCORRECT: 'Birthday incorrect',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      WE_WONT_SHARE_IT: 'We won\'t share it with others.',
      MOBILE_INCORRECT: 'Mobile incorrect',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      EG_IO: 'e.g. i0ONOZLgCIM',
      SERVICE_INCORRECT: 'Service incorrect',
      SERVICE_LABEL: 'Service (20 characters)',
      IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
      SERVICE_NAME_INCORRECT: 'Service name incorrect',
      SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
      SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
      SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
      PRICE_PER_MINUTE: 'Price per minute',
      DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
      YES: 'Yes.',
      NO: 'No.',
      DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
      YES_SAVE: 'Yes, save.',
      DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
      ENTER_TAX_ID: 'Enter tax ID to check',
      CHECK: 'Check.',
      PLEASE_ENTER_PASSWORD: 'Please enter password',
      FIRST_NAME: 'First name',
    },
    SOCIAL_NETWORK: {
      CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
      CONTINUE_WITH_GOOGLE: 'Continue with Google',
    },
    ROUTES: {
      ERROR_404: 'Error 404',
      PAGE_NOT_FOUND: 'Page not found',
      THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
      GO_HOME: 'Go Home',
      FEATURED_SERVICE: 'FEATURED SERVICE',
      WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
      GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
      FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
      CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
      NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
      YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
      RESET: 'Reset',
      BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
      TELMIE_T_C: 'Telmie T&C',
      TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
      AND: 'and',
      STRIPE_T_C: 'Stripe T&C.',
      SORRY: 'Sorry',
      IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
      OR: 'or',
      IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
      BACK_TO_SETTINGS: 'Back to Settings',
      PROFILE_PREVIEW: 'Profile preview',
      PRO_DETAILS: 'Pro details',
      PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
      RESULTS_FOR: 'Results for',
      SORRY_NO_PROS: 'Sorry, no pros found for',
      SELECT_YOUR_INTEREST: 'Select your interest',
      TELMIE_MY_CLIENTS: 'Telmie | My Clients',
      FIND_YOUR_CLIENT: 'Find your Client',
      TELMIE_MY_PROS: 'Telmie | My Pros',
      FIND_YOUR_PRO: 'Find your Pro',
      PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
      TELMIE_PREVIEW: 'Telmie | Preview',
      LOWEST_RATE_FIRST: 'Lowest rate first',
      HIGHEST_RATE_FIRST: 'Highest rate first',
      EXPERIENCE: 'Experience',
      RATING: 'Rating',
      ACTIVITY: 'Activity',
      LANGUAGES: 'Languages',
      COACHING: 'Coaching',
      IMMIGRATION: 'Immigration',
      OTHER: 'Other',
      ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
      ERROR_WITH_STRIPE: 'Error with Stripe.',
      TELMIE_PRO: 'Telmie | Pro',
    },
    FOOTER: {
      HOME: 'Startseite',
      CONTACT: 'Kontaktieren sie uns',
      SUPPORT: 'Support',
      POLICY: 'Datenschutzerklärung',
      TERMS: 'Nutzungsbedingungen',
      FAQ: 'FAQ',
      COPYRIGHT: 'Copyright',
      COPYRIGHT_TEXT: '2018-2022 / TELMIE UK LTD. / London, United Kingdom',

    },
    CONTACT_US: {
      title: 'Kontaktieren sie uns',
      subTitle: 'Haben Sie Fragen? Schicken Sie uns eine Nachricht.',
      name: 'Name',
      email: 'E-mail',
      company: 'Unternehmen',
      subject: 'Betreff',
      message: 'Nachricht eingeben',
      success: 'Vielen Dank für Ihre Anfrage.',
      submitBtn: 'Abschicken',
    },
    SERVICES: {
      LANGUAGE_PRACTICE: 'Sprachtraining',
      IMMIGRATION_CONSULTANT: 'Einwanderungsberater',
      IMMIGRATION_ADVICE: 'Einwanderungsberatung',
      LANGUAGE_LEARNERS: 'Sprachenlernen',
    },
    FAQ: 'FAQ',
    MORE_FAQ: 'Mehr FAQ',
    API: {
      NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content',
    },
    NOTIFICATIONS: {
      DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
      EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
      MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
      SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
      UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!',
    },
    REGISTER_PRO: {
      FIRST_NAME: 'First name',
      FIRST_NAME_ERROR: 'First name field is required',
      LAST_NAME: 'Last name',
      LAST_NAME_ERROR: 'Last name field is required',
      COUNTRY: 'Country',
      COUNTRY_PLACEHOLDER: 'Select country',
      COUNTRY_ERROR: 'Country field is required',
      CITY: 'City',
      POSTCODE: 'Postcode',
      POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
      DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
      DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      MOBILE_HINT: 'We won\'t share it with others.',
      MOBILE_ERROR: 'Must contain only numbers',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
      SERVICES: 'Services',
      SERVICES_PLACEHOLDER: 'Select service',
      SERVICES_ERROR: 'Services field is required',
      SERVICE: 'Service (20 characters)',
      SERVICE_HINT: 'i.e. English practice, Immigration advice',
      SERVICE_ERROR: 'Service name may not be greater than 20 characters',
      SECTOR: 'Sector',
      SECTOR_PLACEHOLDER: 'Select sector',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
      SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
      SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
      SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
      SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
      COST_PER_MINUTE_ERROR: 'Please enter price',
      COST_PER_MINUTE_MAX: 'Maximum allowed for this service',
    },
  },
  [FR]: {
    DOWNLOAD_APP_BTN: 'Télécharger l\'appli',
    HOMEPAGE_FAQ_TITLE: 'Questions les plus populaires',
    GENERAL_QUESTIONS: 'Questions Générales',
    CUSTOMERS_QUESTIONS: 'Clients',
    EXPERTS_QUESTIONS: 'Experts',
    PAYMENTS_QUESTIONS: 'Paiements',
    BLOG_TITLE: 'Blog',
    FULL_STORY_BTN: 'Histoire complète',
    OTHER_POSTS: 'Autres Posts',
    MISC: {
      DELETE: 'Delete',
      UPDATE_NOW: 'Update now',
      CONNECTING: 'Connecting',
      CONNECTING_TO_SERVER: 'Connecting to server',
      CALLING_PRO: 'Calling Pro',
      CREDIT_CARD: 'Credit card',
      ADD_A_CARD: 'Add a card',
      SUBMIT: 'Submit',
      EMAIL: 'Email',
      SAVE: 'Save',
      OK: 'OK',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      PLEASE_ENTER_FIRST_NAME: 'Please enter first name',
      PLEASE_ENTER_LAST_NAME: 'Please enter last name',
      YOU_WILL_PAY: 'You will pay',
      PER_MINUTE_FOR_CALL: 'per minute for this call',
      MINUTES_SHORT: 'min',
      BECOME_PRO: 'Devenir un pro',
      BLOG: 'Blog',
      FIND_A_PRO: 'Find a Pro',
      MY_CLIENTS: 'My Clients',
      MY_PROS: 'My Pros',
      MY_APPOINTMENTS: 'My Appointments',
      SIGN_UP: 'Sign Up',
      LOG_OUT: 'Log out',
      REGISTER_AS_PRO: 'Register as Pro',
      REGISTER: 'Register',
      LOG_IN: 'Log in',
      FORGOT_PASSWORD: 'Forgot password',
      PASSWORD: 'Password',
      DATE: 'Date',
      DATE_AND_TIME: 'Date and time',
      DURATION: 'Duration',
      TYPE: 'Type',
      EDIT: 'Edit',
      NAME: 'Name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      MOBILE: 'Mobile',
      CITY: 'City',
      BUSINESS_NAME: 'Business name',
      COMPANIES_HOUSE_REGISTRATION: 'Companies House registration number',
      COUNTRY: 'Country',
      RATE: 'Rate',
      YOUR_CHANGES_WILL_BE_SENT: 'Your changes will be sent for review',
      CODE_VERIFIED: 'Code verified',
      IN_ORDER_TO_VERIFY_EMAIL: 'In order to verify your email, we will send you 4 characters verification code.',
      CODE_EXPIRES_IN: 'Code expires in',
      CODE: 'Code',
      VERIFY_CODE: 'Verify code',
      PLEASE_ENTER_EMAIL: 'Please enter email',
      RE_SEND_VERIFICATION_CODE: 'Re-send verification code',
      SEND_VERIFICATION_CODE: 'Send verification code',
      LINK_COPIED_SUCCESSFULLY: 'Link is copied successfully',
    },
    BLOG: {
      COMMENTS: 'Comments',
      REPLY: 'Reply',
      ADD_COMMENT: 'Add Comment',
      POST_COMMENT: 'Post comment',
    },
    BOOKING: {
      CLIENT_CANCELLATION_PARTIAL_REFUND: 'You will get £{{amount}} ({{percentage}}) refund to your Telmie credit account. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_FULL_REFUND: 'You will get full refund to your Telmie credit account for cancelling this appointment. Are you sure you want to proceed and cancel?',
      CLIENT_CANCELLATION_NO_REFUND: 'You will not get any refund due to the late cancellation. Are you sure you want to proceed and cancel?',
      CANCELLATION_POLICY: 'Cancellation Policy',
      CANCEL_APPOINTMENT: 'Cancel Appointment',
      PRO_CANCELLATION_CONFIRMATION: 'Are you sure you want to cancel this appointment with your client?',
      YES_CANCEL: 'Yes, cancel',
      NO_KEEP: 'No, keep it',
    },
    COMMUNICATION: {
      ON_CALL_WITH: 'On call with',
      CONNECTING_WITH: 'Connecting with',
      INCOMING_CALL: 'Incoming Call',
      YOUR_CLIENT: 'Your client',
      TYPE_YOUR_MESSAGE: 'Type your message',
      MIN: 'min',
      CALL_WILL_BE_FINISHED: 'Call will be finished automatically in 60 sec.',
    },
    CREDIT_CARD: {
      CARD_NUMBER: 'Card number',
      CARD_HOLDER: 'Card holder',
      EXPIRY_DATE: 'Expiry date',
      CVV: 'CVV',
      CHOOSE_TOP_UP_AMOUNT: 'Choose your top up amount',
      SELECT_YOUR_PAYMENT_METHOD: 'Select your payment method',
      SAVE_PAYMENT_METHOD: 'Save payment method',
      X2_BONUS: 'x2 BONUS',
      YOU_WILL_GET: 'You will get',
      TELMIE_CREDIT: 'Telmie credit',
      IN_TOTAL: 'in total',
      CONFIRM_AND_PAY: 'Confirm & Pay',
      CANNOT_WITHDRAW: 'Cannot withdraw',
      FEE: 'fee',
      FREE: 'Free',
      YOU_ENTERED_NOT_A_NUMBER: 'please enter the amount you would like to withdraw in the field above.',
      AMOUNT_EXCEEDS_YOUR_BALANCE: 'the amount entered exceeds the available amount as stated above',
      AVALIABLE: 'Available',
      AMOUNT_AVALIABLE_WITHDRAWAL: 'Amount available for withdrawal may differ from Earnings due to Pending balances',
      WITHDRAW: 'Withdraw',
      FREE_APPLIES: 'Fee applies: ',
      YOU_RECEIVE: 'You receive: ',
      WITHDRAWAL_RULES: 'Withdrawal rules',
      WITHDRAWAL_AMOUNT: 'Withdrawal amount',
      HIDE: 'Hide',
    },
    EDIT_PROFILE: {
      SORRY_ACCOUNT_EXISTS: 'Sorry, account with this email address already exists',
      CANT_BE_CHANGED: 'Can\'t be changed',
      UPLOAD_PICTURE: 'Upload picture',
      NAME_ISNT_VALID: 'The name isn\'t valid.',
    },
    FEATURED_SERVICE: {
      CALL_NOW: 'Call now',
      CANCEL_CALL: 'Cancel call',
      NEXT_PRO: 'Next pro',
      NEXT_PRO_CAPS: 'NEXT PRO',
      THEN_CAPS: 'THEN',
    },
    HEADER: {
      HOW_IT_WORKS: 'Comment ça marche',
      FAQ: 'FAQ',
      CONTACT: 'Nous contacter',
      MONEY: 'Money',
      SETTINGS: 'Settings',
      LOGIN: 'Log in',
      EDIT_PROFILE: 'Edit Profile',
      NEW_CHATS: 'New Chats',
      WELL_DONE: 'Well done',
      SUCCESSFULLY_ADDED_BALANCE: 'successfully added to your balance',
      EDIT_PRO_DETAILS: 'Edit Pro details',
    },
    HOMEPAGE: {
      FEATURED_PROS: 'Featured Pros',
      FEATURED_SERVICES: 'Featured services',
      DOWNLOAD_TELMIE_APP: 'Download Telmie app',
    },
    LANGUAGE_PRACTICE: {
      HAPPY_PROS: 'Happy Pros',
      HAPPY_USERS: 'Happy Users',
    },
    LOG_IN: {
      LOGIN_DETAILS_NOT_CORRECT: 'Sorry, your login details are not correct',
      NEW_TO_TELMIE: 'New to Telmie',
      DOWNLOAD_THE_APP: 'Download the app',
    },
    NEW_LANDING: {
      MINUTES: 'minutes',
      COMMUNICATED_VIA_TELMIE: 'Communicated via Telmie',
      BROWSER_DOES_NOT_SUPPORT_VIDEO: 'Your browser does not support the video tag.',
      PLEASE_ENTER_SUBJECT: 'Please enter subject',
      PLEASE_ENTER_MESSAGE: 'Please enter message',
    },
    PRO: {
      PRO: 'Pro',
      AMOUNT: 'Amount',
      NO_RECENT_CALLS: 'No recent calls',
      MESSAGES: 'Messages',
      START_CALL: 'Start Call',
      SHORTLISTED: 'Shortlisted',
      REMOVE: 'Remove',
      SHORTLIST: 'Shortlist',
      LOADING: 'Loading',
      TELMIE_CLIENT: 'Telmie Client',
      ON_CALL: 'On call',
      RECONNECTING: 'Reconnecting...',
      TELMIE_USER_IS_CALLING: 'Telmie user is calling',
      SORRY_I_AM_BUISY: 'Sorry, I\'m busy now. Please text me & I will respond ASAP.',
      HOURS_FIRST_LETTER: 'h',
      MINUTES_FIRST_LETTER: 'm',
      CALENDAR_TITLE: 'My availability',
      CALENDAR_SUB_TITLE: 'I am not available right now',
      CALENDAR_AVAILABLE_TEXT: 'I will be happy to talk to you during the periods below or you can text me right now',
      AVAILABLE_NOW: 'Available now',
      AVAILABLE_LATTER: 'Available later',
      WORKING_AS_PRO_OFF: 'Your \'Work as Pro\' setting is OFF. Your existing clients will not be able to call you and your profile is not showing in search. You can change this setting in Dashboard - Pro Settings',
      PRO_IS_BUSY: 'Pro is busy',
    },
    PROFILE: {
      VIEW_ALL: 'View all',
      CONTACT: 'Contact',
      COUNT: 'Count',
      NO_RECENT_ACTIVITY: 'No recent activity',
      YOUR_DETAILS: 'Your details',
      LOCATION: 'Location',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      NO_RECENT_PROS: 'No recent PROS',
      WITHDRAW_EARNINGS: 'Withdraw earnings',
      TOP_UP: 'Top Up',
      ATTACH_CARD: 'Attach card',
      SERVICE: 'Service',
      APPOINTMENT_WITH: 'Appointment with',
      COST: 'Cost',
      BALANCE: 'Balance',
      NO_RECENT_TRANSACTIONS: 'No recent transactions',
      NO_MORE_UPCOMING_APPOINTMENTS: 'You have no more upcoming appointments',
      CLIENT: 'Client',
    },
    RADIO_BUTTONS: {
      APPROVED: 'Approved',
      SECTORS: 'SECTORS',
    },
    SEARCH: {
      FILTERS: 'Filters',
      SESSIONS: 'sessions',
      ARRANGE_BY: 'Arrange by',
      ENTER_KEYWORDS: 'Enter keywords',
      RESET_FILTERS: 'Clear all',
    },
    SELECT: {
      EVERY: 'Every',
    },
    SETTINGS: {
      IMPORTANT_VIA_EMAIL: 'Important via email',
      WORKING_AS_PRO: 'Working as Pro',
      PLEASE_SPECIFY_AVAILABILITY: 'Please specify your availability to accept calls from clients. This availability will be shown in service description on your profile. You will be able to edit your general availability in Settings at any time.',
      ADD_NEW_PERIOD: 'Add new period',
      CHANGE_BANK_ACCOUNT: 'Change bank account',
      ADD_BANK_ACCOUNT: 'Add bank account',
      ENTITY: 'Entity',
      ADDRESS: 'Address',
      YOUR_NAME_ENTITY: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please change it in according sections on this page.',
      WE_HAVE_YOUR_PAYOUT: 'We have your Payout Details successfully registered on file. To make changes please add new details bellow and send for approval.',
      SORT_CODE: 'Sort code',
      DIGITS_VALUE: 'digits value',
      ACCOUNT_NUMBER: 'Account number',
      BAD_REQUEST_DATA: 'Bad Request data',
      PLEASE_UPLOAD_YOUR_ID: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of Telmie Bro.',
      CONFIRM: 'Confirm',
      UPLOAD_ANOTHER_IMAGE: 'Upload another image',
      UPLOAD: 'Upload',
      YOU_ALREADY_VERIFIED_USER: 'You are already verified user. If you want to upload a new document, click on the upload button below.',
      YOU_CAN_ADD_CREDIT_CARD: 'You can add your credit card to make easy payments on demand.',
      PLEASE_NOTE_PROFILE_CHANGE: 'Please note that every new profile change has to go through verification process',
      POST_CODE: 'Post Code',
      LOADING_CARDS: 'Loading cards',
      NO_CARDS: 'No cards.',
      COMPANY_ADDRESS: 'Company address',
      PERSONAL_ADDRESS: 'Personal address',
      SERVICE_NAME: 'Service name',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_SUB_CATEGORY: 'Service sub-category',
      SERVICE_DESCRIPTION: 'Service description',
      PLEASE_SUBMIT_NEW_PRO_ACCOUNT: 'Your name, entity and address should match the details of your bank account. To change any of the info above, please submit new Pro application.',
      LOADING_ACCOUNTS: 'Loading accounts',
      ADD_NEW_BANK_ACCOUNT: 'Add new bank account',
      PLEASE_UPLOAD_YOUR_ID_DETAILS: 'Please upload your ID to lift the £2,000 limit of your payouts. The ID should be either a UK passport or a UK driving licence in the name of',
      THE_START_DATE_MUST_BE_EARLIER: 'The start date must be earlier than the end date',
      DAYS_REQUIRED: 'Please select days',
      FROM: 'From',
      TO: 'To',
      COMPANY: 'Company',
      INDIVIDUAL: 'Individual',
      PERSONAL_SETTINGS: 'PERSONAL SETTINGS',
      PROFILE_DETAILS: 'Profile details',
      PRO_SETTINGS: 'PRO SETTINGS',
      WORK_AS_PRO: 'Work as Pro',
      PRO_DETAILS: 'Pro details',
      PAYOUT_BANK_DETAILS: 'Payout bank details',
      PREVIEW_MY_PROFILE: 'Preview my profile',
      MY_AVAILABILITY: 'My availability',
      HIDE_PROFILE: 'Hide profile',
      GENERAL_SETTINGS: 'GENERAL SETTINGS',
      PAYMENT_SETTINGS: 'Payment settings',
      EMAIL_NOTIFICATION: 'Email notification',
      BECOME_A_TELMIE_PRO: 'Become a Telmie Pro and start earning today!',
      BANK_ACCOUNT: 'Bank account',
      ID_VERIFICATION: 'ID Verification',
      I_WANT_TO_TAKE_PART: 'I want to take part',
    },
    SIGN_UP: {
      CONFIRM_EMAIL: 'Now confirm your email address',
      RESEND: 'Resend',
      CONFIRM_EMAIL_MESSAGE: (email) => <span>We've sent an email to {email}, please check your inbox and click the link 'Activate' to confirm and earn!</span>,
      USE_ANOTHER_EMAIL: 'Use another email',
      SECTOR: 'Sector',
      CATEGORY: 'Category',
      PLEASE_SELECT_CATEGORY: 'Please select category',
      PROFESSION: 'Profession',
      DESCRIPTION: 'Description',
      FREE: 'Free',
      PER_MINUTE: 'per minute',
      BY_CLICKING_SIGNUP_AGREE: 'By clicking on \'Sign Up\' button, I agree to the',
      TERMS_OF_USE: 'Terms of use',
      AND_THE: 'and the',
      PRIVACY_POLICY: 'Privacy Policy',
      THANK_FOR_REGISTRATION: 'Thank you for Telmie registration!',
      CHECK_YOUR_EMAIL: 'Check your e-mail and click a link in Telmie letter to verify your account. After verification you\'ll be free to use Telmie App and web-page.',
      ACCOUNT_TYPE: 'Account type',
      APPLICATION_WAITING_APPROVAL: 'Your application is waiting for approval.',
      CANCEL_CHANGES: 'Cancel changes',
      PLEASE_FILL_MISSED_FIELDS: 'Please fill in all missing fields in the form to proceed.',
      ERROR: 'Error',
      PLEASE_ADD_YOUR_PHOTO: 'Please add your photo',
      UNITED_KINGDOM: 'United Kingdom',
      ONLY_UK_NOW: 'Only UK for now',
      I_LIKE_TO_TAKE_PART: 'I\'d like to take part in the fixed-rate Featured services programme',
      ALREADY_HAVE_ACCOUNT: 'Already have an account',
      CODE_HAVE_BEEN_SENT: 'Code has been sent to',
      EDUCATION: {
        EDUCATION: 'Education',
        LANGUAGE_TUTOR: 'Language tutor',
        LANGUAGE_PRACTICE: 'Language practice',
        EXAMS_PREPARATION: 'Exams preparation',
        SCIENCE: 'Science',
        BUSINESS_STUDIES: 'Business studies',
        SOCIAL_SCIENCE: 'Social science',
        DRAWING: 'Drawing',
        MUSIC: 'Music',
        DANCE: 'Dance',
      },
      SERVICES: {
        SERVICES: 'Services',
        INTERPRETER: 'Interpreter',
        NEGOTIATOR_MEDIATOR: 'Negotiator/mediator',
        THERAPIST: 'Therapist',
        LISTENER: 'Listener',
        SPEECH_THERAPIST: 'Speech therapist',
        FORTUN_TELLER: 'Fortun teller',
        ASTROLOGIST: 'Astrologist',
        PERSONAL_ASSISTANT: 'Personal assistant',
        CAREER_COACH: 'Career coach',
      },
      CONSULTANCY: {
        CONSULTANCY: 'Consultancy',
        LEGAL: 'Legal',
        MEDICAL: 'Medical',
        BUSINESS: 'Business',
        FAMILY: 'Family',
        INVESTMENT: 'Investment',
        TECH_SUPPORT: 'Tech support',
        BEAUTICIAN: 'Beautician',
      },
      HEALTH_LIFESTYLE: {
        HEALTH_LIFESTYLE: 'Health&Lifestyle',
        PERSONAL_TRAINER: 'Personal trainer',
        YOGA_INSTRUCTOR: 'Yuga instructor',
        MEDITATION_INSTRUCTOR: 'Meditation instructor',
        DIETOLOGIST: 'Dietologist',
        SPORT_COACH: 'Sport coach',
        FITNESS_PROFESSIONAL: 'Fitness professional',
        SPIRITUAL_COACH: 'Spiritual coach',
      },
      PLEASE_SELECT_SECTOR: 'Please select sector',
      PLEASE_ENTER_PROFESSION: 'Please enter profession',
      PLEASE_ENTER_DESCRIPTION: 'Please enter description',
      PLEASE_ENTER_ATTRIBUTE: 'Please enter :attribute',
      PLEASE_ENTER_UK_POSTCODE: 'Please enter UK postcode',
      YOU_ARE_UNDER_18: 'You are under 18',
      DO_YOU_WANT_TO_SAVE_APPLICATION: 'Do you want to save your application before you leave?',
      YOU_HAVE_ATTEMPTED_TO_LEAVE: 'You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.',
      PLEASE_ENTER_REGISTRATION_NUMBER: 'Please enter registration number',
      CITY_IN_THE_UK: 'City in the UK',
      CITY_INCORRECT: 'City incorrect',
      POSTCODE: 'Postcode',
      PLEASE_ENTER_POSTCODE: 'Please enter postcode',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      ONLY_UK_ADDRESS: 'Only UK address',
      ADDRESS_INCORRECT: 'Address incorrect',
      ONLY_OVER_18_YEARS_OLD: 'Only over 18 years old for now',
      BIRTHDAY_INCORRECT: 'Birthday incorrect',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      WE_WONT_SHARE_IT: 'We won\'t share it with others.',
      MOBILE_INCORRECT: 'Mobile incorrect',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      EG_IO: 'e.g. i0ONOZLgCIM',
      SERVICE_INCORRECT: 'Service incorrect',
      SERVICE_LABEL: 'Service (20 characters)',
      IE_ENGLISH_PRACTICE: 'i.e. English practice, Immigration advice',
      SERVICE_NAME_INCORRECT: 'Service name incorrect',
      SERVICE_SECTOR_INCORRECT: 'Service sector incorrect',
      SERVICE_CATEGORY_INCORRECT: 'Service category incorrect',
      SERVICE_DESCRIPTION: 'Service description (100-500 characters) e.g. tell about yourself, languages you speak, your license, qualifications and expirience, the times when you are normally available.',
      PRICE_PER_MINUTE: 'Price per minute',
      DO_YOU_WANT_TO_CANCEL: 'Do you want to cancel your application?',
      YES: 'Yes.',
      NO: 'No.',
      DO_YOU_WANT_APP_BEFORE_LEAVE: 'Do you want to save your application before you leave?',
      YES_SAVE: 'Yes, save.',
      DONT_SAVE_MY_DETAILS: 'Don’t save my details.',
      ENTER_TAX_ID: 'Enter tax ID to check',
      CHECK: 'Check.',
      PLEASE_ENTER_PASSWORD: 'Please enter password',
      FIRST_NAME: 'First name',
    },
    SOCIAL_NETWORK: {
      CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
      CONTINUE_WITH_GOOGLE: 'Continue with Google',
    },
    ROUTES: {
      ERROR_404: 'Error 404',
      PAGE_NOT_FOUND: 'Page not found',
      THE_PAGE_DOESNT_EXIST: 'The page you are looking for doesn\'t exist or you don\'t have enough rights to view it.',
      GO_HOME: 'Go Home',
      FEATURED_SERVICE: 'FEATURED SERVICE',
      WE_HEARED_FORGOTTEN_PASSWORD: 'We heard you’ve forgotten your password.',
      GENERATED_PASS_SENT_to_EMAIL: 'Not to worry - we will send a link to a password reset page to your email.',
      FIRST_NEED_VERIFY_EMAIL: 'But first we need to verify your email.',
      CODE_HAS_BEEN_SENT_TO: 'Code has been sent to',
      NEW_PASSWORD: 'Excellent! Your email has been verified. Now, please enter the new password:',
      YOUR_PASSWORD_HAS_BEEN_RESET: 'Your password has been reset',
      RESET: 'Reset',
      BY_REGISTERING_YOU_ACCEPT: 'By registering you accept',
      TELMIE_T_C: 'Telmie T&C',
      TELMIE_PRIVACY_POLICY: 'Telmie Privacy Policy',
      AND: 'and',
      STRIPE_T_C: 'Stripe T&C.',
      SORRY: 'Sorry',
      IN_ORDER_TO_SEARCH: 'In order to search or view pros you have to be logged in',
      OR: 'or',
      IT_ONLY_TAKES_10_SECONDS: 'It only takes 10 seconds',
      BACK_TO_SETTINGS: 'Back to Settings',
      PROFILE_PREVIEW: 'Profile preview',
      PRO_DETAILS: 'Pro details',
      PLEASE_NOTE_NEW_PROFILE: 'Please note that every new profile change has to go through verification process',
      RESULTS_FOR: 'Results for',
      SORRY_NO_PROS: 'Sorry, no pros found for',
      SELECT_YOUR_INTEREST: 'Select your interest',
      TELMIE_MY_CLIENTS: 'Telmie | My Clients',
      FIND_YOUR_CLIENT: 'Find your Client',
      TELMIE_MY_PROS: 'Telmie | My Pros',
      FIND_YOUR_PRO: 'Find your Pro',
      PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
      TELMIE_PREVIEW: 'Telmie | Preview',
      LOWEST_RATE_FIRST: 'Lowest rate first',
      HIGHEST_RATE_FIRST: 'Highest rate first',
      EXPERIENCE: 'Experience',
      RATING: 'Rating',
      ACTIVITY: 'Activity',
      LANGUAGES: 'Languages',
      COACHING: 'Coaching',
      IMMIGRATION: 'Immigration',
      OTHER: 'Other',
      ADDING_NEW_BANK_ACCOUNT: 'Adding new bank account...',
      ERROR_WITH_STRIPE: 'Error with Stripe.',
      TELMIE_PRO: 'Telmie | Pro',
    },
    FOOTER: {
      HOME: 'Accueil',
      CONTACT: 'Nous contacter',
      SUPPORT: 'Support',
      POLICY: 'Politique de Confidentialité',
      TERMS: 'Modalités',
      FAQ: 'FAQ',
      COPYRIGHT: 'Copyright',
      COPYRIGHT_TEXT: '© 2018-2022 / TELMIE UK LTD. / London, United Kingdom',
    },
    CONTACT_US: {
      title: 'Nous contacter',
      subTitle: 'Une question ? Écrivez-nous.',
      name: 'Nom',
      email: 'E-mail',
      company: 'Société',
      subject: 'Sujet',
      message: 'Saisissez votre message',
      success: 'Merci de nous avoir contacté',
      submitBtn: 'Soumettre',
    },
    SERVICES: {
      LANGUAGE_PRACTICE: 'Pratique d\'une langue',
      IMMIGRATION_CONSULTANT: 'Expert en Immigration',
      IMMIGRATION_ADVICE: 'Conseils en immigration',
      LANGUAGE_LEARNERS: 'Apprentissage de langue',
    },
    FAQ: 'FAQ',
    MORE_FAQ: 'Plus de FAQ',
    API: {
      NOTIFICATION_MESSAGE: 'Please, click on this message to refresh this page and see its content',
    },
    NOTIFICATIONS: {
      DOWNLOAD_TO_USE_ON_MOBILE: 'Download the Telmie app to use Telmie on your mobile device',
      EMAIL_VALIDATED_SUCCESSFULLY: 'Your email has been validated successfully. You can continue registration on your mobile device or you can also log in with your account details on this page.',
      MAX_ATTACHED_FILES_AMOUNT: 'Max attached files amount',
      SUPPORTED_FILE_TYPES: 'This file format is not supported yet. Please, send files in the following formats:',
      UPDATE_APPLICATION_VERSION: 'To continue using Telmie, please update the app to the latest version. Thank you!',
    },
    REGISTER_PRO: {
      FIRST_NAME: 'First name',
      FIRST_NAME_ERROR: 'First name field is required',
      LAST_NAME: 'Last name',
      LAST_NAME_ERROR: 'Last name field is required',
      COUNTRY: 'Country',
      COUNTRY_PLACEHOLDER: 'Select country',
      COUNTRY_ERROR: 'Country field is required',
      CITY: 'City',
      POSTCODE: 'Postcode',
      POSTCODE_ERROR: 'Must contain only letters, numbers, and spaces',
      DATE_OF_BIRTH_MIN_ERROR: 'You are under 18',
      DATE_OF_BIRTH_MAX_ERROR: 'You are over 100',
      PERSONAL_ADDRESS_LINE: 'Personal address line',
      MOBILE_PHONE: 'Mobile phone (i.e. +447123456789)',
      MOBILE_HINT: 'We won\'t share it with others.',
      MOBILE_ERROR: 'Must contain only numbers',
      YOUTUBE_ID: 'YouTube ID (11 characters)',
      YOUTUBE_HINT: 'e.g. i0ONOZLgCIM',
      SERVICES: 'Services',
      SERVICES_PLACEHOLDER: 'Select service',
      SERVICES_ERROR: 'Services field is required',
      SERVICE: 'Service (20 characters)',
      SERVICE_HINT: 'i.e. English practice, Immigration advice',
      SERVICE_ERROR: 'Service name may not be greater than 20 characters',
      SECTOR: 'Sector',
      SECTOR_PLACEHOLDER: 'Select sector',
      SERVICE_CATEGORY: 'Service category',
      SERVICE_CATEGORY_PLACEHOLDER: 'Select category',
      SERVICE_DESCRIPTION: 'Service description (500-10000 characters)',
      SERVICE_DESCRIPTION_ERROR: 'Please enter service description',
      SERVICE_DESCRIPTION_MIN_ERROR: 'Service description may not be smaller than 500 characters',
      SERVICE_DESCRIPTION_MAX_ERROR: 'Service description may not be greater than 10000 characters',
      COST_PER_MINUTE_ERROR: 'Please enter price',
      COST_PER_MINUTE_MAX: 'Maximum allowed for this service',
    },
  },
};



// WEBPACK FOOTER //
// ./utils/langPack.js